/** Supplemental English strings (merged into main translations). */
export default {
  nav: {
    home: 'Home',
    brandName: 'Gadkot',
    explore: 'Explore',
    exploreGallery: 'Maharashtra Heritage Gallery',
    exploreGalleryDesc: 'Forts, sacred places, history and arms',
    tools: 'Tools',
    toolsGallery: 'Swarajya Knowledge Gallery',
    toolsGalleryDesc: 'Journeys, history, learning and community',
    toolsGalleryFooter: 'Gadkot • Knowledge • Journeys • Conservation',
    organizationsGallery: 'Heritage Groups & Institutions',
    organizationsGalleryDesc: 'Conservation, research, culture and service',
    organizationsGalleryFooter: 'Unity • Service • Culture • Conservation',
    search: 'Search',
    tagline: 'Explore Heritage',
    fortsDesc: 'Historical fortresses',
    nearbyForts: 'Nearby Forts',
    nearbyFortsDesc: 'Real distances from your location',
    templesDesc: 'Sacred sites',
    trekPlanner: 'Trek Planner',
    trekPlannerDesc: 'Plan your journey',
    emergency: 'Emergency & Rescue',
    emergencyDesc: 'Hotlines, rescue teams, fort trek emergencies',
    contributions: 'Contributions',
    contributionsDesc: 'Share experiences',
    fortGuide: 'AI Fort Guide',
    fortGuideDesc: 'Ask about any fort in Marathi or English',
    community: 'Community',
    communityDesc: 'Creators, rewards, referrals & alerts',
    quiz: 'Quiz',
    quizDesc: 'Test your knowledge',
    shortNotes: 'Short Notes',
    shortNotesDesc: 'Study material',
    learn: 'Learn',
    learnDesc: 'Educational content',
    institutionPortal: 'Schools & Colleges',
    institutionPortalDesc: 'Group visits and worksheets',
    audiobooks: 'Marathi Audiobooks',
    audiobooksDesc: 'Fort stories and legends',
    badges: 'Badges',
    badgesDesc: 'Achievement system',
    blogDesc: 'Stories & articles',
    wades: 'Wades',
    wadesDesc: 'Historic mansions & havelis',
    history: 'History',
    historyDesc: 'Historical information & chronicles',
    books: 'Heritage Books',
    booksDesc: 'Read fort history, guides & devotional PDFs online',
    heritage: 'Heritage Hub',
    heritageDesc: 'Bhakta Gadkot, sardars, places, partners',
    heritageGallery: 'Heritage Gallery',
    heritageGalleryDesc: 'Forts, temples, wadas, weapons & community photos',
    wishlist: 'Wishlist',
    visitPlanner: 'Visit Planner',
    signIn: 'Sign In',
    account: 'Account',
    accountMenuHint: 'Sign in or create a heritage profile',
    adminSection: 'Admin',
    adminDashboard: 'Admin dashboard',
    uploadManage: 'Upload & manage',
    manageOrganization: 'Manage my organization',
    organizationSection: 'Organization',
    geographicExplorer: 'Geographic Explorer',
    thematicRoutes: 'Thematic Routes',
    organizations: 'Organizations & Groups',
    events: 'Events Calendar',
    eventsDesc: 'Fort festivals, jatra, treks & heritage walks',
    shop: 'Heritage Shop',
    shopDesc: 'Books, trek gear, digital guides & merch',
    weapons: 'Weapons & Information',
    weaponsDesc: 'Historical weapons of the Maratha era',
    organizationCategories: {
      fortConservation: 'Fort Conservation Organizations',
      fortEnthusiastGroups: 'Fort Enthusiast Groups',
      trekkingGroups: 'Trekking Groups',
      historyStudyCircles: 'History Study Circles',
      historyResearchInstitutes: 'History Research Institutes',
      socialOrganizations: 'Social Organizations',
      environmentalConservation: 'Environmental Conservation Organizations',
      shivjayantiFestivalCommittees: 'Shiv Jayanti Festival Committees',
      ganeshFestivalCommittees: 'Ganesh Festival Committees',
      culturalGroups: 'Cultural Groups',
      rescueGroups: 'Disaster Management / Rescue Groups',
    },
  },
  organizations: {
    seoDescription: 'Fort conservation, trekking, history, and cultural organizations and groups.',
    subtitle: 'Organizations and groups connected to forts, history, and heritage in Maharashtra.',
    loadError: 'Could not load organizations.',
    loading: 'Loading…',
    noResults: 'No organizations listed in this category yet.',
    searchPlaceholder: 'Search organizations or location…',
    districtFilter: 'District',
    resultsCount: '{{count}} organizations found',
    viewDetails: 'View details',
    backToHub: 'Organizations & Groups',
    backToCategory: 'Back to category',
    about: 'About',
    overview: 'Overview',
    history: 'History & background',
    activities: 'Activities & focus',
    team: 'Team & office bearers',
    pageSections: 'Page sections',
    eventsSubtitle: 'Upcoming and annual programs',
    viewEventsCalendar: 'Full events calendar',
    noGallery: 'No photos uploaded yet.',
    noEvents: 'No events listed yet.',
    contact: 'Contact',
    gallery: 'Gallery',
    events: 'Events',
    members: 'Members',
    documents: 'Documents',
    socialLinks: 'Social media',
    typeDetails: 'Category details',
    established: 'Est.',
    registration: 'Reg. no.',
    rescueHotlineTitle: '24×7 emergency contact',
    rescueHotlineDesc: 'Tap to call this rescue / disaster management team.',
    yes: 'Yes',
    no: 'No',
    fields: {
      fortsConserved: 'Forts conserved',
      conservationProjectsCount: 'Conservation projects',
      membershipCount: 'Membership count',
      affiliatedForts: 'Affiliated forts',
      focusArea: 'Focus area',
      beneficiariesCount: 'Beneficiaries',
      registrationType: 'Registration type',
      ganpatiName: 'Ganpati name',
      mandalEstablishedYear: 'Mandal established',
      idolHeightFt: 'Idol height (ft)',
      annualBudget: 'Annual budget',
      wardName: 'Ward',
      celebrationDate: 'Celebration date',
      annualPrograms: 'Annual programs',
      affiliatedVillages: 'Affiliated villages',
      trekFrequency: 'Trek frequency',
      difficultyLevel: 'Difficulty level',
      maxGroupSize: 'Max group size',
      equipmentProvided: 'Equipment provided',
      fortsCovered: 'Forts covered',
      annualFortVisits: 'Annual fort visits',
      membershipType: 'Membership type',
      researchFocus: 'Research focus',
      publicationsCount: 'Publications',
      libraryAvailable: 'Library',
      environmentalFocus: 'Environmental focus',
      projectsCount: 'Projects count',
      treePlantationCount: 'Tree plantation',
      culturalActivities: 'Cultural activities',
      artForms: 'Art forms',
      annualEventsCount: 'Annual events',
      rescueSpecialization: 'Rescue specialization',
      teamSize: 'Team size',
      equipmentList: 'Equipment',
      emergencyContact24x7: '24×7 emergency contact',
    },
  },
  share: {
    whatsapp: 'WhatsApp',
    whatsappLabel: 'Share on WhatsApp',
    fortMessage: '{{name}} — explore forts & heritage on Gadkot',
    eventMessage: '{{title}} — Gadkot event calendar',
    eventsMessage: 'Heritage festivals, jatra & events — Gadkot calendar',
    thematicRouteMessage: '{{name}} — thematic route on Gadkot',
    organizationMessage: '{{name}} — organization on Gadkot',
  },
  events: {
    seoTitle: 'Festival & Event Calendar — Gadkot',
    seoDescription: 'Fort festivals, jatra, trek dates, and heritage walks across Maharashtra — from Gadkot community organizations.',
    badge: 'Festivals · Jatra · Treks · Heritage',
    title: 'Festival & Event Calendar',
    subtitle: 'Fort utsav, jatra, group treks, and heritage walks — programs listed by organizations across Maharashtra.',
    tithiCalendarLink: 'Hindu tithi history calendar',
    viewCalendar: 'Month view',
    viewList: 'List view',
    searchPlaceholder: 'Search events, places, organizers…',
    districtFilter: 'District',
    typeFilter: 'Type',
    allCategories: 'All categories',
    loading: 'Loading events…',
    loadError: 'Could not load events.',
    resultsCount: '{{count}} events',
    filteredLocally: 'filtered by type',
    noEvents: 'No events in this period',
    noEventsHint: 'Try another month, remove filters, or browse organizations to see their programs.',
    viewOrganizer: 'View organizer',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    selectedDay: 'Showing events for',
    clearDay: 'Show all days',
    footerNote: 'Events are submitted by registered organizations. Dates and details — verify with the organizer before travel.',
    cta: 'Browse events',
    submit: {
      cta: 'Submit your event',
      title: 'List your festival, trek, or heritage program',
      subtitle: 'Submit details for admin review. Approved events appear on the public calendar.',
      organization: 'Organization / Mandal',
      selectOrganization: 'Choose your organization…',
      eventTitle: 'Event title',
      eventTitlePlaceholder: 'e.g. Shiv Jayanti utsav at Sinhagad',
      eventDate: 'Event date',
      location: 'Location',
      locationPlaceholder: 'Fort name, village, or address',
      description: 'Description',
      yourName: 'Your name',
      email: 'Email',
      phone: 'Phone',
      send: 'Submit for approval',
      close: 'Close',
      requiredError: 'Please fill organization, title, date, and your name.',
      error: 'Could not submit event.',
      orgsLoadError: 'Could not load organizations. Please refresh the page.',
      noOrganizations: 'No published organizations yet. Ask your mandal admin to publish the organization first, or browse /organizations.',
      successTitle: 'Submitted successfully',
      successMessage: 'Thank you! An admin will review your event. Once approved, it will appear on the calendar.',
    },
    types: {
      all: 'All',
      festival: 'Festival / Utsav',
      jatra: 'Jatra / Yatra',
      trek: 'Trek / Fort visit',
      heritageWalk: 'Heritage walk',
      program: 'Program',
    },
  },
  adminEvents: {
    title: 'Event approvals',
    subtitle: 'Review public event submissions before they appear on /events.',
    nonePending: 'No pending event submissions.',
    approve: 'Approve',
    reject: 'Reject',
    confirmReject: 'Confirm reject',
    rejectNotePlaceholder: 'Optional note for rejection (internal)',
    submittedBy: 'Submitted by',
    unknownOrg: 'Unknown organization',
    loadError: 'Could not load pending events.',
    approveError: 'Could not approve event.',
    rejectError: 'Could not reject event.',
  },
  adminThematicRoutes: {
    title: 'Thematic routes',
    subtitle: 'Manage curated heritage travel routes shown on /thematic-routes.',
    add: 'Add route',
    refresh: 'Refresh',
    searchPlaceholder: 'Search routes…',
    none: 'No thematic routes yet.',
    colName: 'Name',
    colSlug: 'Slug',
    colDuration: 'Duration',
    colStops: 'Stops',
    colStatus: 'Status',
    createTitle: 'New thematic route',
    editTitle: 'Edit thematic route',
    slug: 'URL slug',
    name: 'Route name',
    description: 'Description',
    duration: 'Duration label',
    durationFilter: 'Duration filter',
    difficulty: 'Difficulty',
    bestTime: 'Best time',
    icon: 'Icon',
    status: 'Status',
    image: 'Cover image URL',
    highlights: 'Highlights (one per line)',
    experiences: 'Experiences (one per line)',
    stops: 'Stops on route',
    addStop: 'Add stop',
    removeStop: 'Remove',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    requiredError: 'Slug and name are required.',
    loadError: 'Could not load thematic routes.',
    saveError: 'Could not save route.',
    deleteError: 'Could not delete route.',
    deleteConfirm: 'Delete "{{name}}"?',
  },
  auth: {
    welcomeBack: 'Welcome back',
    createAccount: 'Create your account',
    email: 'Email',
    password: 'Password',
    name: 'Full name',
    confirmPassword: 'Confirm password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signingIn: 'Signing in…',
    creatingAccount: 'Creating account…',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    registerLink: 'Register',
    loginLink: 'Sign in',
    registerMenuDesc: 'New member — add treks, forts & heritage details',
    signInMenuDesc: 'Already have an account',
    modalBadge: 'Gadkot Heritage Portal',
    signInSubtitle: 'Sign in to save forts, treks, and your heritage journey.',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    nameRequired: 'Name is required',
    passwordsMismatch: 'Passwords do not match',
    generalError: 'Something went wrong. Please try again.',
    pleaseWait: 'Please wait...',
    createAccountBtn: 'Create Account',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email',
    passwordPlaceholder: 'Enter your password',
    confirmPasswordPlaceholder: 'Confirm your password',
  },
  register: {
    badge: 'Maharashtra Heritage • Gadkot',
    pageTitle: 'Join the Heritage Chronicle',
    pageSubtitle: 'Create your account and record your fort treks, temple visits, and Maratha heritage journey.',
    stepsLabel: 'Registration steps',
    stepAccount: 'Account',
    stepHeritage: 'Heritage profile',
    previewLabel: 'Your heritage scroll',
    heritageScore: 'Heritage score',
    continueHeritage: 'Continue to heritage profile',
    heritageIntro: 'Tell us about your heritage explorations — these details appear on your profile and help calculate your explorer rank.',
    treksCompleted: 'Treks completed',
    fortsVisited: 'Forts visited',
    templesVisited: 'Temples visited',
    wadasVisited: 'Wadas visited',
    heritageSitesVisited: 'Heritage sites visited',
    yearsExploring: 'Years exploring heritage',
    homeDistrict: 'Home district',
    homeDistrictPlaceholder: 'e.g. Pune, Satara',
    favoriteEra: 'Favourite historic era',
    eraShiv: 'Shivaji Maharaj era',
    eraPeshwa: 'Peshwa era',
    eraAncient: 'Ancient & medieval',
    eraAll: 'All eras',
    bioLabel: 'Heritage story (optional)',
    bioPlaceholder: 'Share your passion for forts, treks, temples, or Maratha history…',
    back: 'Back',
    createAndJoin: 'Create account & join',
    rankPathfinder: 'Pathfinder',
    rankFortWalker: 'Fort Walker',
    rankGuardian: 'Heritage Guardian',
    rankChronicler: 'Maratha Chronicler',
    heritageProfileTitle: 'Heritage profile',
    editHeritage: 'Edit heritage details',
    noHeritageYet: 'Add your heritage journey from registration or edit below.',
    namePlaceholder: 'Your name',
    signInRequired: 'Please sign in to view your profile',
  },
  ui: {
    pleaseWait: 'Please wait...',
    goBack: 'Go Back',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
  },
  errors: {
    seoTitle404: '404 — Page not found | Gadkot',
    notFoundBadge: 'Lost on the Sahyadri trail',
    notFoundTitle: 'Page Not Found',
    notFoundMessage:
      "The page you're looking for doesn't exist. Let's get you back to exploring Maharashtra's heritage.",
    notFoundQuote:
      'When the path is unclear, return to the known fort gate — the journey to Swarajya continues from there.',
    notFoundQuoteAttr: '— Heritage traveller\'s note',
    notFoundStory:
      'Like a hidden fort gate closed for the night, this address is not yet on Gadkot\'s map. Choose a path below and continue your journey through forts, sacred places, and history.',
    heritagePaths: 'Find your way — heritage paths',
    continueJourney: 'Well-trodden routes from forts to chronicles',
    pathForts: 'Hill forts of Swarajya',
    pathFortsDesc: 'Raigad, Rajgad, Shivneri and hundreds of Maharashtra forts',
    pathTemples: 'Sacred shrines',
    pathTemplesDesc: 'Temples on forts and bhakti routes across the state',
    pathHeritage: 'Heritage Hub',
    pathHeritageDesc: 'Sardars, historic places, gallery, partners & books',
    pathHistory: 'History & chronicles',
    pathHistoryDesc: 'Historic articles, maps, and “today in history”',
    pathBooks: 'Heritage books',
    pathBooksDesc: 'Read Marathi fort history and guides online',
    pathSearchDesc: 'Search forts, temples, wadas, and historic places',
    backToSafety: 'Return home (fort gateway)',
    aboutGadkot: 'About Gadkot',
    heritageClosing: 'Maharashtra\'s forts have stood for centuries — this missing page is only a small detour.',
    goHome: 'Go Home',
    searchSite: 'Search Site',
    whatNext: 'What to Do Next',
    suggestion1: 'Check the URL for spelling mistakes',
    suggestion2: "Use search to find forts, temples, or places you're looking for",
    suggestion3: 'Browse popular categories below',
    suggestion4: 'Return to the home page and start exploring',
    tipLabel: 'Tip:',
    tipText: 'Use the search bar at the top of any page to quickly find forts and temples.',
    popularDestinations: 'Popular Destinations',
    exploreNow: 'Explore now →',
    stillCantFind: "Still can't find what you're looking for?",
    searchPlaceholder: 'Search for forts, temples, or places…',
    popularSearches: 'Popular searches:',
    needHelp: 'Need Help?',
    needHelpText:
      'If you believe this is an error, our team can help you discover Maharashtra\'s historical heritage.',
    contactSupport: 'Contact Support',
    reportIssue: 'Report Issue',
    quickForts: 'Historical Forts',
    quickTemples: 'Sacred Temples',
    genericTitle: 'Something went wrong',
    genericMessage: 'Please try again or return to the home page.',
    backHome: 'Back to Home',
  },
  geo: {
    title: 'Geographic Explorer',
    subtitle: 'Browse forts and temples across Maharashtra by region',
    heritageBadge: 'Maharashtra • Regions • Heritage',
    searchPlaceholder: 'Search by name or place…',
    allRegions: 'All regions',
    allTypes: 'All',
    forts: 'Forts',
    temples: 'Temples',
    thematicRoutes: 'Thematic routes',
    viewForts: 'All forts',
    viewTemples: 'All temples',
    sitesFound: '{{count}} places',
    fortCount: '{{count}} forts',
    templeCount: '{{count}} temples',
    loading: 'Loading places…',
    loadError: 'Could not load places. Is the backend running?',
    noResults: 'No places match your filters',
    noResultsHint: 'Try another region or search term',
    built: 'Built',
    difficulty: 'Difficulty',
    deity: 'Deity',
  },
  thematicRoutes: {
    heritageBadge: 'Curated routes • Forts • Heritage',
    routesCountLabel: 'Thematic routes',
    overviewSiteCount: '{{count}} stops',
    routeNotFound: 'Route not found',
    routeNotFoundHint: 'The thematic route you requested does not exist.',
    pageTitle: 'Thematic Routes',
    pageSubtitle:
      'Curated journeys through Maharashtra\'s heritage — forts, temples, and culture on one path',
    searchPlaceholder: 'Search routes, places, or experiences…',
    durationAll: 'All durations',
    durationShort: '2–5 days',
    durationMedium: '5–8 days',
    durationLong: '8+ days',
    routesFound: 'routes found',
    durationLabel: 'Duration',
    bestTimeLabel: 'Best time',
    sitesLabel: 'Stops',
    destinations: 'Destinations',
    viewRoute: 'View route',
    highlights: 'Route highlights',
    experiences: 'Experiences',
    overview: 'Thematic routes — overview',
    overviewDesc:
      'Curated travel routes on Gadkot — each path follows a distinct historical theme across Maharashtra.',
    noRoutes: 'No routes found',
    noRoutesHint: 'Try a different search term or duration filter',
    backToRoutes: 'All routes',
    planTrip: 'Plan a trek',
    exploreForts: 'Browse all forts',
    difficultyLabel: 'Difficulty',
    stopsTitle: 'Stops on this route',
    stopFort: 'Fort',
    stopTemple: 'Temple',
    stopNature: 'Nature',
    seoTitle: 'Thematic Routes — Maharashtra Heritage | Gadkot',
    seoDescription:
      'Shivaji trail, Konkan coast, sacred Maharashtra, and more — discover curated thematic travel routes.',
  },
  search: {
    title: 'Search',
    subtitle: 'Find forts, temples, and heritage sites',
    heritageBadge: 'Forts • Temples • Heritage',
    placeholder: 'Search forts, temples, places…',
    searchButton: 'Search',
    showingResults: 'Showing {{count}} results',
    matchPercent: '{{percent}}% match',
    filterLabel: 'Filters',
    categoryAll: 'All categories',
    categoryFort: 'Forts',
    categoryTemple: 'Temples',
    categoryBlog: 'Blogs',
    categoryRegion: 'Regions',
    categoryRoute: 'Routes',
    sortRelevance: 'Most relevant',
    sortName: 'Name (A–Z)',
    sortYear: 'Year (oldest)',
    sortHeight: 'Height (highest)',
    sortBy: 'Sort by',
    tipsTitle: 'Try searching for',
    tipSpelling: 'Check spelling or alternate names',
    tipKeywords: 'Broader keywords (e.g. Sahyadri, Shivaji)',
    tipBrowse: 'Browse forts or temples from the home page',
    noResults: 'No results found',
    noResultsFor: 'No results found for "{{query}}"',
    noResultsHint: 'Try a different search term',
    searching: 'Searching…',
    resultsFor: 'Results for "{{query}}"',
    resultsCount: '{{count}} results found',
    allItems: 'All items',
    errorLoading: 'Could not load search results',
    searchingTitle: 'Searching...',
    searchingHint: 'Finding the best results for you',
    filters: 'Filters',
    signInToFavorite: 'Please sign in to add items to your favorites',
    linkCopied: 'Link copied to clipboard!',
    typeFort: 'Historical Fort',
    typeTemple: 'Sacred Temple',
    typeBlog: 'Blog',
    typeRegion: 'Geographic Region',
    typeRoute: 'Thematic Route',
    typeSite: 'Site',
  },
  adminSidebar: {
    title: 'Admin',
    subtitle: 'Gadkot heritage',
    uploadManage: 'Upload & manage',
    blogModeration: 'Blog moderation',
    mediaLibrary: 'Media library',
    organizations: 'Organizations',
    eventApprovals: 'Event approvals',
    thematicRoutes: 'Thematic routes',
    dailyHistory: 'Today in History',
    weapons: 'Weapons & Information',
  },
  weapons: {
    seoDescription: 'Historical weapons of the Maratha period, Swarajya era, and Indian warfare.',
    subtitle: 'Detailed information about swords, spears, shields, cannons, and other historic weapons.',
    loadError: 'Could not load weapons.',
    noResults: 'No weapons listed in this category yet.',
    notFound: 'Weapon not found.',
    searchPlaceholder: 'Search weapons (e.g. Talwar, Bhala)…',
    resultsCount: '{{count}} weapons found',
    viewDetails: 'View details',
    backToHub: 'Weapons & Information',
    allWeapons: 'All weapons',
    prevPage: 'Previous',
    nextPage: 'Next',
    gallery: 'Image gallery',
    noGallery: 'No images uploaded yet.',
    zoom: 'Zoom',
    relatedWeapons: 'Related weapons',
    categories: {
      edged: 'Edged weapons',
      piercing: 'Piercing weapons',
      projectile: 'Projectile weapons',
      firearms: 'Firearms',
      defensive: 'Defensive weapons',
    },
    sections: {
      intro: 'Introduction',
      detailed: 'Detailed information',
      history: 'History',
      usage: 'Usage',
      advantages: 'Advantages',
      disadvantages: 'Disadvantages',
      famousUsage: 'Famous usage',
      relatedForts: 'Related forts',
      relatedPersonalities: 'Related historical figures',
    },
    specs: {
      title: 'Specifications',
      type: 'Type',
      period: 'Period',
      weight: 'Weight',
      length: 'Length / size',
      material: 'Material',
    },
  },
  adminOrganizations: {
    title: 'Organizations dashboard',
    subtitle: 'Create and manage organizations, groups, and mandals. Only administrators can add, edit, or delete.',
    addOrg: 'Add organization',
    editOrg: 'Edit organization',
    newOrg: 'New organization',
    refresh: 'Refresh',
    search: 'Search',
    filterCategory: 'Category',
    noOrgs: 'No organizations yet. Add one to get started.',
    saveFirstHint: 'Save the organization first, then you can add gallery photos, events, team members, and documents.',
    stats: {
      orgs: 'Organizations',
      categories: 'Categories',
      members: 'Members',
      events: 'Events',
      districts: 'Districts',
    },
  },
  home: {
    heritageBadge: 'Gateway to Maratha heritage',
    heritageMotto: 'Forts • Temples • History • Culture',
    visitCounterLabel: 'Heritage seekers at Gadkot’s gateway',
    todayPick: {
      badge: 'Daily suggestion',
      title: 'What to explore today?',
      subtitle: 'Today’s tithi, a featured fort and temple, plus season and weather guidance — all from our heritage database.',
      tithiLabel: 'Today’s tithi event',
      fortLabel: 'Fort today',
      templeLabel: 'Temple today',
      seasonLabel: 'Season & weather',
      loading: 'Loading today’s heritage pick…',
      error: 'Could not load today’s pick',
      readTithi: 'Read more',
      openCalendar: 'Open tithi calendar',
      viewFort: 'View fort',
      viewTemple: 'View temple',
      liveWeather: 'Live forecast (featured fort)',
      trekCaution: 'trek with caution',
      viewFull: 'View full section',
      errorHint: 'Restart the backend and open GET /api/v1/site/today-heritage-pick — the section appears on the home page below the hero.',
    },
    readAllBlogs: 'Read All Blogs',
    writeYourStory: 'Write Your Story',
    exploreHeritage: 'Explore Heritage',
    exploreHeritageSubtitle: 'Discover India\'s rich historical legacy through our curated collections',
    geoExplorerDesc: 'Discover sites across regions and themes',
    geoExplorerCta: 'Explore',
    thematicRoutesDesc: 'Curated journeys through history',
    thematicRoutesCta: 'Discover',
    historicalFortsTitle: 'Historical Forts',
    historicalFortsDesc: 'Explore magnificent fortresses',
    historicalFortsCta: 'Visit',
    sacredTemplesTitle: 'Sacred Temples',
    sacredTemplesDesc: 'Experience spiritual heritage',
    sacredTemplesCta: 'Worship',
    featuredFortsTitle: 'Featured Forts',
    featuredFortsSubtitle: 'Explore three remarkable forts from Maharashtra\'s heritage',
    featuredSections: {
      title: 'Start exploring',
      subtitle: 'Four paths into Maharashtra heritage — pick one to begin.',
      forts: {
        title: 'Forts & treks',
        desc: 'Browse every fort with maps, trek guides, and nearby search from your location.',
        cta: 'Browse forts',
      },
      map: {
        title: 'Map & regions',
        desc: 'Explore forts and heritage sites by district, region, and curated thematic routes.',
        cta: 'Open map',
      },
      events: {
        title: 'Events calendar',
        desc: 'Fort festivals, heritage walks, jatra, and community gatherings near you.',
        cta: 'See events',
      },
      trek: {
        title: 'Trek planner',
        desc: 'Plan routes, checklists, seasonal tips, and share live trek status with your group.',
        cta: 'Plan a trek',
      },
    },
    viewAllForts: 'View All Forts',
    viewFort: 'View Fort',
    loadingForts: 'Loading forts…',
    noFeaturedForts: 'No forts available right now. Check back soon.',
    fortLoadError: 'Could not load featured forts',
    features: {
      badge: 'Everything in one place',
      title: 'What can you do on Gadkot?',
      subtitle: 'Forts, temples, trek tools, and community — everything you need to explore Maharashtra\'s heritage.',
      openFeature: 'Explore',
      ctaTrek: 'Open Trek Planner',
      ctaForts: 'Browse All Forts',
      categories: {
        explore: 'Heritage & Explore',
        trek: 'Trek & Tools',
        community: 'Community',
        discover: 'Discover & Routes',
      },
      forts: {
        title: 'Historical Forts',
        desc: 'Maharashtra forts with maps, timelines, and trek guides on every detail page.',
      },
      temples: {
        title: 'Sacred Temples',
        desc: 'Ancient temples, jyotirlingas, and spiritual heritage across the state.',
      },
      wades: {
        title: 'Historic Wadas',
        desc: 'Mansions, wadas, and architectural cultural heritage.',
      },
      history: {
        title: 'History',
        desc: 'Maratha empire, battles, and chronicles of Maharashtra.',
      },
      weapons: {
        title: 'Weapons Gallery',
        desc: 'Swords, spears, shields, cannons, and historic arms explained.',
      },
      blog: {
        title: 'Blog',
        desc: 'Stories, articles, and experiences from history lovers and travelers.',
      },
      search: {
        title: 'Smart Search',
        desc: 'Find forts, temples, and heritage sites by name, region, or theme.',
      },
      events: {
        title: 'Events Calendar',
        desc: 'Fort festivals, jatra, trek dates, and heritage walks from community organizations.',
      },
      trekPlanner: {
        title: 'Trek Planner',
        desc: 'Create or join group treks and plan your next Sahyadri adventure.',
      },
      nearbyForts: {
        title: 'Nearby Forts',
        desc: 'Find forts near your GPS location or any town — real straight-line distances on the heritage map.',
      },
      checklist: {
        title: 'Trek Checklist',
        desc: 'Gear, safety, and seasonal prep lists — works offline too.',
      },
      weather: {
        title: 'Weather & Trek Guide',
        desc: 'Per-fort trek guides, weather, and emergency contacts.',
      },
      liveStatus: {
        title: 'Live Trek Status',
        desc: 'Share a safe link with family while you\'re on the trail.',
      },
      trekDiary: {
        title: 'Trek Diary',
        desc: 'Photos, notes, and memories — log your trek experience.',
      },
      seasonal: {
        title: 'Seasonal Treks',
        desc: 'Which forts suit monsoon, winter, or summer — seasonal picks.',
      },
      contributions: {
        title: 'Contributions',
        desc: 'Share photos, facts, and experiences — help preserve heritage.',
      },
      organizations: {
        title: 'Organizations',
        desc: 'Groups and mandals connected to forts, history, and heritage.',
      },
      buddyFinder: {
        title: 'Trek Buddy Finder',
        desc: 'Join community treks or start a group — never trek alone.',
      },
      expenseSplit: {
        title: 'Expense Split',
        desc: 'Split trek costs in your group — travel, food, and more made easy.',
      },
      geoExplorer: {
        title: 'Geographic Explorer',
        desc: 'Browse forts and temples by region, district, and map.',
      },
      thematicRoutes: {
        title: 'Thematic Routes',
        desc: 'Curated journeys through history, empires, and heritage themes.',
      },
    },
  },
  temples: {
    heritageBadge: 'Sacred temples • Heritage • Maharashtra',
    templesCountLabel: 'Temples',
    templesFound: '{{count}} temples found',
    searchPlaceholder: 'Search by name, place, or deity…',
    loading: 'Loading temples…',
    loadError: 'Could not load temples. Is the backend running?',
    noTemples: 'No temples found',
    noTemplesHint: 'Try a different search term or check back later',
    viewForts: 'Browse forts',
    viewTemple: 'View temple',
    badge: 'Temple',
    seoTitle: 'Sacred Temples — Maharashtra Heritage | Gadkot',
    seoDescription: 'Discover ancient temples, jyotirlingas, and spiritual heritage across Maharashtra.',
    notFound: 'Temple not found',
    notFoundHint: 'The temple you requested does not exist.',
    backToTemples: 'All temples',
    about: 'About',
    keyFeatures: 'Key features',
  },
  templeDetail: {
    heritageBadge: 'Sacred temple • Heritage • Maharashtra',
    keyInformation: 'Key information',
    quickInfo: 'Quick info',
    location: 'Location',
    deity: 'Deity',
    bestTime: 'Best time to visit',
    visitingHours: 'Visiting hours',
    visitingHoursDefault: '6:00 AM – 8:00 PM (daily)',
    keyFeatures: 'Key features',
    noFeatures: 'No key features listed yet.',
    onMap: 'Location on map',
    audioGuideTitle: 'Audio guide',
    audioGuideDescription: 'Listen to stories about this temple in Marathi or English.',
    startAudioGuide: 'Start audio guide',
    audioGuide: 'Audio guide',
    gallery: 'Gallery',
    visitInfo: 'Visit information',
    dressCode: 'Dress code',
    dressCodeDefault: 'Modest attire required. Cover shoulders and knees.',
    photography: 'Photography',
    photographyDefault: 'Allowed in most areas. Check for restrictions near the sanctum.',
    facilities: 'Facilities',
    facilitiesDefault: 'Parking, restrooms, and drinking water available.',
    howToReach: 'How to reach',
    howToReachDefault: 'Accessible by road from nearby towns and cities.',
    share: 'Share',
    signInForFavorites: 'Please sign in to add temples to your favorites.',
    linkCopied: 'Link copied to clipboard!',
  },
  fortDetail: {
    heritageBadge: 'Sahyadri • Fort • Heritage',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',
    about: 'About',
    keyInformation: 'Key information',
    visitingHours: 'Visiting hours',
    audioGuideAvailable: 'Audio guide available',
    audioGuideDescription: 'Listen to the history and stories of this fort',
    startAudioGuide: 'Start audio guide',
    richMedia: 'Media experiences',
    virtualTour: 'Virtual tour',
    videoDocumentary: 'Video documentary',
    historicalTimeline: 'Historical timeline',
    architectureDetails: 'Architecture details',
    storiesLegends: 'Stories & legends',
    navLocationFeatures: 'Navigation & location',
    gpsNavigation: 'GPS navigation',
    arView: 'AR view',
    offlineMaps: 'Offline maps',
    nearbyPlaces: 'Nearby places',
    multimediaExperiences: 'Multimedia experiences',
    audioGuides: 'Audio guides',
    qrScanner: 'QR scanner',
    virtualTour360Short: '360° tour',
    reenactments: 'Historic reenactments',
    communitySocialFeatures: 'Community & social',
    photoCommunity: 'Photo community',
    reviews: 'Reviews',
    checkIn: 'Check-in',
    socialShare: 'Social share',
    myProfile: 'My profile',
    notFound: 'Fort not found',
    backToForts: 'All forts',
    quickInfo: 'Quick info',
    location: 'Location',
    builtIn: 'Built in',
    elevation: 'Elevation',
    bestTimeToVisit: 'Best time to visit',
    share: 'Share',
    audioGuide: 'Audio guide',
    signInForFavorites: 'Please sign in to add forts to your favorites.',
    noKeyFeatures: 'No key features listed for this fort yet. See the description above for access details.',
  },
  quiz: {
    title: 'Heritage Quiz',
    subtitle: 'Test your knowledge of forts, temples, and history',
    category: 'Category',
    difficulty: 'Difficulty',
    questionCount: 'Number of questions',
    startQuiz: 'Start Quiz',
    loading: 'Loading…',
    question: 'Question',
    of: 'of',
    finish: 'Finish',
    results: 'Results',
    score: 'Score',
    correct: 'Correct',
    incorrect: 'Incorrect',
    tryAgain: 'Try Again',
    selectCategory: 'Select category',
    selectDifficulty: 'Select difficulty',
    metaError: 'Could not load quiz options',
    sessionError: 'Could not start quiz',
    submitError: 'Could not submit answer',
    subtitleDb: 'Questions are loaded from the backend database.',
    startNew: 'Start a new quiz',
    startDesc: 'Pick optional filters and begin. Correct answers are validated on the server.',
    allCategories: 'All categories',
    allDifficulties: 'All difficulties',
    questionsLabel: 'Questions',
  },
  trek: {
    title: 'Trek Planner',
    subtitle: 'Plan group treks, see who\'s coming, and join upcoming adventures.',
    heritageBadge: 'Sahyadri • Forts • Community',
    statUpcoming: 'Upcoming treks',
    statPast: 'Past treks',
    statCommunity: 'Participants',
    newTrekPlan: 'New trek plan',
    upcoming: 'Upcoming',
    past: 'Past',
    join: 'Join',
    youreIn: "You're in",
    signInToJoin: 'Sign in to join upcoming treks',
    createdBy: 'Created by',
    participants: 'Participants',
    noParticipants: 'No participants yet.',
    loadError: 'Failed to load trek plans',
    joinError: 'Could not join this trek',
    createError: 'Could not create trek plan',
    loading: 'Loading trek plans…',
    serverErrorTitle: 'Could not reach the server',
    upcomingTreks: 'Upcoming treks',
    pastTreks: 'Past treks',
    noUpcoming: 'No upcoming treks yet. Be the first to create one.',
    noPast: 'No past treks to show.',
    createTrekPlan: 'Create trek plan',
    formTitle: 'Title',
    formLocation: 'Location',
    formTrekDate: 'Trek date',
    formDescription: 'Description',
    placeholderTitle: 'e.g. Rajgad night trek',
    placeholderLocation: 'e.g. Pune, Maharashtra',
    placeholderDescription: 'Meeting point, difficulty, what to bring…',
    cancel: 'Cancel',
    save: 'Save',
    unknown: 'Unknown',
    user: 'User',
    hubCommunity: 'Community treks',
    hubChecklist: 'Checklist',
    hubOffline: 'Offline',
    hubLive: 'Live status',
    hubLog: 'Trek diary',
    hubSeasonal: 'This season',
    formMaxParticipants: 'Max participants',
    formDifficulty: 'Difficulty',
    checklist: {
      water_bottle: 'Water bottles (2–3 L)',
      snacks: 'Snacks / fruit',
      trek_shoes: 'Trekking shoes',
      cap_sunscreen: 'Cap & sunscreen',
      first_aid: 'First aid kit',
      id_card: 'ID card',
      power_bank: 'Power bank',
      raincoat: 'Raincoat / rain gear',
      head_torch: 'Head torch',
      extra_batteries: 'Extra batteries',
      warm_layer: 'Warm layer / jacket',
      whistle: 'Whistle',
      waterproof_bag: 'Waterproof bag',
      extra_clothes: 'Extra clothes',
      anti_leech_socks: 'Leech socks',
      warm_jacket: 'Warm jacket',
      gloves: 'Gloves',
      energy_bars: 'Energy bars',
    },
  },
  trekEssentials: {
    title: 'Trek guide',
    weather: 'Weather & safety',
    trekSafe: 'Good for trekking',
    trekCaution: 'Caution — rain/storm',
    bestStart: 'Best start time',
    bestSeason: 'Best season',
    baseVillage: 'Base village',
    parking: 'Parking',
    duration: 'Duration',
    beginner: 'Beginner',
    fit: 'Experienced',
    monsoonSafe: 'Monsoon-safe trek',
    monsoonCaution: 'Extra caution in monsoon',
    waterPoints: 'Water points',
    foodPoints: 'Food / shops',
    transport: 'Transport',
    bus: 'Bus',
    train: 'Train',
    jeep: 'Jeep / shared taxi',
    lastReturn: 'Last return',
    emergency: 'Emergency contacts',
    trailConditions: 'Recent trail reports',
    noReports: 'No reports yet.',
    reportPlaceholder: 'Describe trail conditions…',
    submitReport: 'Submit report',
    saveOffline: 'Save offline',
    offlineSaved: 'Fort info saved on this device.',
    openTrekHub: 'Open trek planner',
    checklistTitle: 'Trek checklist',
    checklistTypes: { day: 'Day', night: 'Night', monsoon: 'Monsoon', winter: 'Winter' },
    liveStatusTitle: 'I am on trek',
    liveStatusDesc: 'Share status with family — tap “Safe home” when back.',
    liveStatuses: {
      started: 'Trek started',
      at_top: 'At summit',
      descending: 'Descending',
      safe_home: 'Safe at home',
    },
    shareWithFamily: 'Link for family',
    copyLink: 'Copy',
    logTitle: 'My trek diary',
    fortId: 'Fort ID',
    fortIdOptional: 'Fort ID (optional)',
    durationHours: 'Hours',
    distanceKm: 'Distance (km)',
    logNotes: 'Notes',
    addLog: 'Add entry',
    seasonalTitle: 'Forts for this season',
    noSeasonal: 'No suggestions available.',
    seasonal: {
      currentSeason: 'Current season',
      tipsTitle: 'Season tips',
      avoidTitle: 'Watch out for',
      packingTitle: 'What to pack',
      recommended: 'Recommended forts this season',
      filterDistrict: 'Filter by district',
      allDistricts: 'All districts',
      noForts: 'No forts match this filter.',
      viewFort: 'View fort details',
      browseAllForts: 'Browse all forts',
      openChecklist: 'Open checklist',
      reasons: {
        winterBest: 'Oct–Feb — peak trekking season in the Sahyadri.',
        summerEarly: 'Start early — heat builds quickly after mid-morning.',
        summerHard: 'Hard route — experienced trekkers only; begin at dawn.',
        monsoonSafe: 'Monsoon-safe — use a local guide and check trail reports.',
        monsoonCheck: 'Check trail conditions — scenic but slippery in rain.',
        monsoonEasy: 'Easy/medium route — extra caution in monsoon.',
        monsoonHard: 'Difficult fort — better avoided in heavy rain.',
        general: 'Trek with proper prep and check weather before you go.',
      },
      summer: {
        name: 'Summer / Pre-monsoon',
        months: 'March – May',
        intro: 'Start between 5–6 AM. Midday heat, fatigue, and dehydration risk rise fast. Easy and medium forts work well now — carry extra water, a hat, and sunscreen.',
        bestFor: 'Easy & medium forts — Lohagad, Sinhagad, Torna, forts near Karjat.',
        tip1: 'Begin before sunrise or by 6 AM — aim to be back by 10 AM.',
        tip2: 'Carry 3–4 L water per person, ORS/electrolytes, and nimbu pani or sugarcane juice.',
        tip3: 'Wear light colours, cap, sunscreen, and sunglasses.',
        tip4: 'Avoid exposed rock in midday — pick shaded routes.',
        tip5: 'Tell family your route and time; watch the weather app.',
        avoid1: 'Open summit treks between 11 AM and 3 PM.',
        avoid2: 'Long or hard routes without enough water.',
        avoid3: 'Descending while exhausted from heat — rest when needed.',
      },
      monsoon: {
        name: 'Monsoon',
        months: 'June – September',
        intro: 'Trails turn slippery, waterfalls run strong, and flash-flood risk increases. Pick only monsoon-safe forts. Rain gear, leech socks, and clear visibility matter most.',
        bestFor: 'Monsoon-safe forts — Sinhagad, Rajmachi, Lohagad, Visapur (verify local reports).',
        tip1: 'Check seasonal alerts, local guides, and fort trail reports before you go.',
        tip2: 'Leech socks, raincoat, and waterproof bag are essential.',
        tip3: 'Avoid overnight on forts — day treks with early return.',
        tip4: 'Descend immediately if thunder appears — avoid open summits.',
        tip5: 'Keep spare clothes in a sealed bag; phone in a waterproof pouch.',
        avoid1: 'Steep rock where one slip can be fatal.',
        avoid2: 'Crossing waterfalls when flow is strong.',
      },
      winter: {
        name: 'Winter — best trek season',
        months: 'October – February',
        intro: 'The finest window for Sahyadri treks. Cool air and clear views. Even difficult forts are fair game — but nights are cold and sunset is early.',
        bestFor: 'All fort types — Harishchandragad, Kalsubai, Torna, forts across Ratnagiri district.',
        tip1: 'Dec–Jan: carry a warm layer — it gets colder at the summit.',
        tip2: 'Sunset around 6–6:30 PM — torch/headlamp for any night section.',
        tip3: 'Popular forts get crowded — weekdays are quieter.',
        tip4: 'For camping, get permission and follow fire-safety rules.',
        tip5: 'Full-day treks: snacks, 3 L+ water, and first aid.',
        avoid1: 'Early starts in Dec–Jan without warm clothing.',
        avoid2: 'Unplanned night descent after sunset.',
      },
    },
    selectFort: 'Select fort',
    seatsLeft: 'seats left',
    expenses: 'Expense split',
    paidBy: 'Paid by',
    expenseDesc: 'Description',
    amount: 'Amount (₹)',
    addExpense: 'Add expense',
    liveShareTitle: 'Trek status',
    liveNotFound: 'Status not found',
    signInRequired: 'Please sign in to use this feature.',
    sessionExpired: 'Session expired. Please sign in again.',
    liveUpdateError: 'Could not update status.',
    atFort: 'Fort',
    expectedSafe: 'Expected safe by',
    lastUpdate: 'Last update',
    reportTypes: {
      muddy: 'Muddy trail',
      gate_closed: 'Gate closed',
      leeches: 'Leeches',
      waterfall: 'Waterfall active',
      other: 'Other',
    },
  },
  contributions: {
    title: 'Contributions',
    subtitle: 'Share your fort trek experiences. Submissions are reviewed before they appear publicly.',
    heritageBadge: 'Community • Experiences • Heritage',
    reviewNote: 'All submissions are reviewed by admins before publication.',
    published: 'Published',
    gallery: 'Gallery',
    submit: 'Submit',
    myContributions: 'My contributions',
    loadError: 'Failed to load contributions',
    loadMineError: 'Failed to load your contributions',
    submitError: 'Submission failed',
    noPublished: 'No published contributions yet.',
    loadMore: 'Load more',
    loading: 'Loading…',
    signInToSubmit: 'Sign in to submit a contribution.',
    formTitle: 'Title',
    formExperience: 'Your experience',
    formFort: 'Fort / place',
    formRating: 'Rating (1–5)',
    formDifficulty: 'Difficulty',
    formBestTime: 'Best time to visit',
    formTips: 'Tips for other trekkers',
    formPhotos: 'Photo links (optional)',
    formPhotosHint: 'Up to 10 HTTPS image URLs, one per line.',
    placeholderExperience: 'Describe your trek, what you saw, and how it felt.',
    placeholderFort: 'e.g. Sinhagad Fort',
    placeholderBestTime: 'e.g. Winter mornings, monsoon for greenery',
    placeholderPhotos: 'https://example.com/photo1.jpg',
    submitForReview: 'Submit for review',
    pendingNote: 'Your entry will be pending until an admin approves it.',
    signInToSeeMine: 'Sign in to see your submissions.',
    noMineYet: "You haven't submitted anything yet.",
    contributor: 'Contributor',
    difficultyLabel: 'Difficulty:',
    tipsLabel: 'Tips for trekkers:',
    reasonLabel: 'Reason:',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',
    difficultyExpert: 'Expert',
    statusApproved: 'Approved',
    statusPending: 'Pending',
    statusRejected: 'Rejected',
  },
  adminFeatures: {
    sections: {
      overview: 'Overview',
      creators: 'Creator listings',
      content: 'Content management',
      moderation: 'Moderation',
      reference: 'Reference data',
      system: 'System',
    },
    status: {
      live: 'Live',
      partial: 'Partial',
      planned: 'Planned',
    },
    ops: {
      view: 'View',
      create: 'Add',
      update: 'Edit',
      delete: 'Delete',
      approve: 'Approve',
      reject: 'Reject',
      moderate: 'Moderate',
    },
    open: 'Open',
    capabilities: {
      title: 'Admin capabilities',
      desc: 'All admin features, their status, and available operations.',
    },
    dashboard: { desc: 'Overview counts and quick links.' },
    contentHub: { desc: 'Forts, temples, blogs, and media in one hub.' },
    forts: { title: 'Fort management', desc: 'Full CRUD for fort records and cover images.' },
    temples: { title: 'Temple management', desc: 'Full CRUD for temple records and cover images.' },
    wadas: { title: 'Wadas', desc: 'Historic mansions and wadas shown on /wades.' },
    historicInfo: { title: 'Historic information', desc: 'History articles and multi-part stories.' },
    organizations: { desc: 'Organizations, members, events, gallery, documents — plus org-representative self-service portal.' },
    eventModeration: { title: 'Event approvals', desc: 'Approve or reject public event submissions for the calendar.' },
    thematicRoutes: { title: 'Thematic routes', desc: 'Curated heritage travel routes — Shivaji trail, Konkan coast, and more.' },
    orgCategories: { title: 'Org categories', desc: 'Organization type categories (trek groups, mandals, etc.).' },
    dailyHistory: { desc: 'Today in History calendar events.' },
    weapons: { desc: 'Weapons encyclopedia entries and images.' },
    shop: { title: 'Heritage shop', desc: 'Products, pricing, stock, and catalog for /shop.' },
    education: { title: 'Heritage education', desc: 'Learning paths, lessons, notes, worksheets, audiobooks, and timelines.' },
    books: { title: 'Heritage books', desc: 'PDF library — upload covers, publish free/read-online books for /books.' },
    weaponCategories: { title: 'Weapon categories', desc: 'Weapon grouping labels.' },
    fortTrekGuide: { title: 'Fort trek guides', desc: 'Season, safety, and trek info per fort.' },
    media: { desc: 'Media library uploads used across the site.' },
    blogs: { desc: 'Blog moderation — approve, reject, feature posts.' },
    contributions: { desc: 'User trek contribution approvals.' },
    visitBookings: { title: 'Visit tickets', desc: 'Bookings list, cancel, resend email/SMS.' },
    sardars: { title: 'Sardars', desc: 'Heritage sardars — add, edit biography, war details, village, forts.' },
    photos: { title: 'Photo moderation', desc: 'Approve or delete pending fort photos.' },
    contentReview: { title: 'Content review queue', desc: 'Unified inbox for pending contributions, photos, blogs, events, and creator listings.' },
    users: { desc: 'View, create, edit, and delete registered user accounts and roles.' },
    analytics: { desc: 'Live platform metrics from the database and server runtime.' },
    site: { desc: 'Site branding, hero text, contact details, and SEO metadata.' },
    community: { desc: 'Moderate contributions, photos, blogs, and reviews; manage community policy.' },
    language: { title: 'Language & translations', desc: 'Translation management (planned).' },
    settings: { desc: 'Platform toggles, registration, language defaults, and upload limits.' },
    planned: {
      title: 'Feature not fully wired yet',
      desc: 'This area is defined for admin rights but needs backend API or UI completion.',
      status: 'Status',
      operations: 'Planned operations',
      noBackend: 'No admin API exists yet — backend work is required before add/edit/delete.',
      viewAll: 'View all admin capabilities',
      details: 'View details',
    },
  },
  admin: {
    dashboard: 'Dashboard',
    users: 'Users',
    blogs: 'Blogs',
    content: 'Content',
    site: 'Site',
    media: 'Media',
    analytics: 'Analytics',
    community: 'Community',
    settings: 'Settings',
    review: 'Review',
    language: 'Language',
    upload: 'Upload',
    contributions: 'Contributions',
    accessDenied: 'Admin access required',
    signInPrompt: 'Please sign in with an admin account.',
  },
  adminAnalytics: {
    refresh: 'Refresh',
    lastUpdated: 'Last updated',
    lastChecked: 'Last checked',
    tabs: {
      overview: 'Overview',
      content: 'Content',
      engagement: 'Engagement',
      system: 'System',
    },
    sections: {
      contentMix: 'Content mix',
      catalog: 'Catalog totals',
      publishedContent: 'Published content',
      mediaLibrary: 'Media library',
      users: 'Users & activity',
      contributions: 'Contributions',
      runtime: 'Server runtime',
      healthNote: 'About these metrics',
    },
    metrics: {
      users: 'Registered users',
      adminsHint: '{{count}} admins',
      forts: 'Forts',
      temples: 'Temples',
      blogs: 'Blog posts',
      reviews: 'Fort reviews',
      media: 'Media assets',
      trekPlans: 'Trek plans',
      pending: 'Pending contributions',
      pendingHint: '{{photos}} photos awaiting moderation',
      wadas: 'Wadas',
      organizations: 'Organizations',
      weapons: 'Weapons',
      historicArticles: 'Historic articles',
      dailyHistory: 'Daily history events',
      contributions: 'Contributions',
      mediaAssets: 'Media files',
      mediaStorage: 'Total storage',
      imageAssets: 'Images',
      videoAssets: 'Videos',
      approvedPhotos: 'Approved fort photos',
      pendingPhotos: 'Pending fort photos',
      registeredUsers: 'Registered users',
      adminUsers: 'Admin accounts',
      visitsLogged: 'Visit log entries',
      favoritesSaved: 'Saved favorites',
      contributionsTotal: 'Total submitted',
      contributionsPending: 'Pending',
      contributionsApproved: 'Approved',
      contributionsRejected: 'Rejected',
      status: 'Status',
      uptime: 'Uptime',
      memoryUsed: 'Memory used',
      memoryMax: 'Memory max',
      memoryUsage: 'Heap usage',
      dbRecords: 'Core DB records',
    },
    note: {
      engagement: 'Counts reflect stored user activity (reviews, visits, favorites, contributions, treks).',
      system: 'Runtime metrics come from the Spring Boot JVM process. They reflect server health, not visitor traffic.',
      traffic: 'Visitor traffic, page views, and search analytics are not tracked yet. This dashboard shows real catalog and engagement data from your database.',
    },
    empty: { content: 'No catalog content recorded yet.' },
    errors: {
      load: 'Failed to load analytics.',
      forbidden: 'Admin access required.',
    },
  },
  adminSite: {
    refresh: 'Refresh',
    save: 'Save changes',
    saving: 'Saving…',
    saved: 'Site settings saved.',
    sections: { brand: 'Brand & hero', contact: 'Contact & social', emergency: 'Emergency hotlines', seo: 'SEO & footer' },
    fields: {
      name: 'Site name',
      tagline: 'Tagline',
      heroTitle: 'Hero title',
      heroSubtitle: 'Hero subtitle',
      contactEmail: 'Contact email',
      contactPhone: 'Main contact phone',
      contactLocation: 'Location',
      emergencyHelpline: 'Portal emergency hotline',
      rescueHelpline: 'Rescue coordination hotline',
      nationalEmergency: 'National emergency number',
      socialHandle: 'Social handle',
      metaDescription: 'Meta description',
      footerNotice: 'Footer notice (optional)',
    },
    hints: {
      emergency: 'Shown on /emergency and the Contact page. Use E.164 or local format with country code.',
    },
    errors: { load: 'Failed to load site settings.', save: 'Failed to save site settings.' },
  },
  adminContentReview: {
    title: 'Content review queue',
    subtitle: 'Approve or reject all pending user submissions from one place.',
    refresh: 'Refresh',
    approve: 'Approve',
    reject: 'Reject',
    confirmReject: 'Confirm reject',
    cancel: 'Cancel',
    openTool: 'Open tool',
    empty: 'Nothing waiting for review — you are all caught up.',
    confirmRejectAction: 'Reject this submission?',
    rejectNotePlaceholder: 'Optional note for the submitter (events & creator listings)',
    manageDeep: 'Need more detail? Open the dedicated moderation screens:',
    filters: {
      all: 'All pending',
      contribution: 'Contributions',
      photo: 'Photos',
      blog: 'Blogs',
      event: 'Events',
      creator: 'Creators',
    },
    types: {
      contribution: 'Contribution',
      photo: 'Photo',
      blog: 'Blog',
      event: 'Event',
      creator: 'Creator listing',
    },
    errors: {
      load: 'Could not load the review queue.',
      action: 'Action failed. Try again or use the dedicated admin screen.',
    },
  },
  adminEducation: {
    title: 'Heritage education manager',
    subtitle: 'Create learning paths, lessons, short notes, worksheets, audiobooks, timelines, and manage school visit requests — no JSON editing required.',
    refresh: 'Refresh',
    save: 'Save content',
    create: 'Create',
    edit: 'Edit',
    add: 'Add {{type}}',
    confirmArchive: 'Archive “{{title}}”?',
    tabs: { content: 'Education content', visits: 'Institution visits ({{count}})' },
    types: {
      learningPath: 'Learning paths',
      lesson: 'Lessons',
      shortNote: 'Short notes',
      worksheet: 'Worksheets',
      audiobook: 'Audiobooks',
      timelineEvent: 'Timeline events',
    },
    table: { title: 'Title', category: 'Category', order: 'Order', status: 'Status', actions: 'Actions' },
    status: { active: 'Published', draft: 'Draft' },
    badges: { mp3Ready: 'MP3 ready', noMp3: 'No MP3', fileReady: 'File ready', noFile: 'No file' },
    empty: 'No {{type}} yet.',
    visitStatus: {
      PENDING: 'Pending',
      CONTACTED: 'Contacted',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      COMPLETED: 'Completed',
    },
    visits: {
      empty: 'No institution visit requests yet.',
      anyFort: 'Any fort',
      flexibleDate: 'Date flexible',
      students: '{{count}} students',
    },
    eventKinds: {
      BATTLE: 'Battle',
      CORONATION: 'Coronation',
      FORT_CAPTURE: 'Fort capture',
      BIRTH: 'Birth / origin',
      OTHER: 'Other',
    },
    form: {
      titleEn: 'English title *',
      titleMr: 'Marathi title',
      descriptionEn: 'English description',
      descriptionMr: 'Marathi description',
      learningPath: 'Learning path *',
      selectPath: 'Select path',
      year: 'Year',
      eventKind: 'Event type',
      selectEventKind: 'Select event type',
      fort: 'Linked fort',
      selectFort: 'Select fort (optional)',
      category: 'Category',
      categoryPlaceholder: 'history, exam, architecture…',
      audience: 'Audience',
      audiencePlaceholder: 'Students, MPSC, Grades 6–10…',
      duration: 'Duration (minutes)',
      sortOrder: 'Display order',
      structuredEn: 'English content (structured)',
      structuredMr: 'Marathi content (structured)',
      keyPoints: 'Key points',
      addPoint: 'Add point',
      keyPointPlaceholder: 'One learning point per line',
      examTips: 'Exam tips',
      addExamTip: 'Add exam tip',
      examTip: 'Exam tip',
      examTipPlaceholder: 'Revision or exam advice',
      activity: 'Class activity (optional)',
      activityPlaceholder: 'Hands-on task for students',
      quiz: 'Quiz questions (optional)',
      quizEmpty: 'No quiz questions yet.',
      question: 'Question',
      answer: 'Answer',
      addQuiz: 'Add question',
      worksheetSections: 'Worksheet tasks / sections',
      addSection: 'Add section',
      sectionPlaceholder: 'e.g. Sketch the fort gate before your visit',
      chapters: 'Chapter list (English)',
      chaptersMr: 'Chapter list (Marathi)',
      chapterNumber: 'Chapter {{n}}',
      chapterTitle: 'Chapter title',
      chapterText: 'Narration text (optional — shown in admin only; audio file is what visitors hear)',
      addChapter: 'Add chapter',
      audioFile: 'MP3 audio file *',
      worksheetFile: 'Worksheet PDF/DOC file *',
      audioPlaceholder: 'Upload MP3 or paste audio URL',
      worksheetPlaceholder: 'Upload PDF/DOC or paste file URL',
      uploadMp3: 'Upload MP3',
      uploadDoc: 'Upload PDF/DOC',
      audioHint: 'Recorded MP3 is required before publishing. Drafts can be saved without audio.',
      worksheetHint: 'Printable PDF or Word file is required before publishing. Drafts can be saved without a file.',
      previewWorksheet: 'Preview worksheet file',
      published: 'Published and visible on the site',
      uploadMp3First: 'upload MP3 first',
      uploadDocFirst: 'upload file first',
    },
    errors: {
      load: 'Could not load education administration data.',
      save: 'Could not save education content.',
      archive: 'Could not archive content.',
      upload: 'File upload failed.',
      visit: 'Could not update visit status.',
      audiobookFile: 'Published audiobooks require an uploaded MP3 file.',
      worksheetFile: 'Published worksheets require an uploaded PDF or DOC file.',
      mp3Only: 'Audiobooks must use MP3 files (.mp3).',
      docOnly: 'Worksheets must use PDF or Word files (.pdf, .doc, .docx).',
    },
  },
  adminSettings: {
    refresh: 'Refresh',
    save: 'Save changes',
    saving: 'Saving…',
    saved: 'System settings saved.',
    maintenanceWarning: 'Maintenance mode is ON. Public users may be blocked when this is enforced in the app.',
    sections: { platform: 'Platform controls', defaults: 'Defaults & limits' },
    fields: {
      maintenanceMode: 'Maintenance mode',
      registrationEnabled: 'Allow new registrations',
      publicSearchEnabled: 'Public search enabled',
      defaultLanguage: 'Default language',
      maxUploadMb: 'Max upload size (MB)',
      supportEmail: 'Support email',
    },
    hints: {
      maintenanceMode: 'When enabled, shows that the site is under maintenance.',
      registrationEnabled: 'Allow visitors to create new accounts.',
      publicSearchEnabled: 'Allow unauthenticated search API usage.',
    },
    errors: { load: 'Failed to load system settings.', save: 'Failed to save system settings.' },
  },
  adminCommunity: {
    refresh: 'Refresh',
    approve: 'Approve',
    reject: 'Reject',
    savePolicy: 'Save policy',
    policySaved: 'Community policy saved.',
    quickLinks: 'Dedicated admin pages',
    confirmReject: 'Reject this contribution?',
    confirmDeletePhoto: 'Delete this photo submission?',
    confirmDeleteReview: 'Delete this review permanently?',
    tabs: {
      overview: 'Overview',
      contributions: 'Contributions',
      photos: 'Photos',
      blogs: 'Blogs',
      reviews: 'Reviews',
      policy: 'Policy',
    },
    stats: {
      contributions: 'Pending contributions',
      photos: 'Pending photos',
      blogs: 'Pending blogs',
      reviews: 'Total reviews',
    },
    columns: {
      fort: 'Fort',
      user: 'User',
      rating: 'Rating',
      comment: 'Comment',
      date: 'Date',
      actions: 'Actions',
    },
    fields: {
      guidelines: 'Community guidelines',
      moderationEnabled: 'Require moderation for user content',
      autoApproveContributions: 'Auto-approve contributions',
      allowPhotoUploads: 'Allow photo uploads',
      allowReviews: 'Allow fort reviews',
    },
    empty: {
      creators: 'No creator listings yet.',
      contributions: 'No pending contributions.',
      photos: 'No pending photos.',
      blogs: 'No pending blog posts.',
      reviews: 'No reviews yet.',
    },
    errors: {
      load: 'Failed to load community data.',
      save: 'Failed to save policy.',
      action: 'Action failed.',
      forbidden: 'Admin access required.',
    },
  },
  adminUsers: {
    refresh: 'Refresh',
    addUser: 'Add user',
    editUser: 'Edit user',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    empty: 'No users found.',
    searchPlaceholder: 'Search by name or email…',
    allRoles: 'All roles',
    confirmDelete: 'Delete user "{{name}}"? This cannot be undone.',
    stats: { total: 'Listed users', admins: 'Admins' },
    columns: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      organization: 'Organization',
      joined: 'Joined',
      actions: 'Actions',
    },
    fields: {
      fullName: 'Full name',
      email: 'Email',
      role: 'Role',
      organization: 'Linked organization',
      password: 'Password',
      passwordOptional: 'New password (leave blank to keep current)',
    },
    selectOrganization: 'Select organization…',
    errors: {
      load: 'Failed to load users.',
      save: 'Failed to save user.',
      delete: 'Failed to delete user.',
      forbidden: 'Admin access required.',
      required: 'Name and email are required.',
      password: 'Password must be at least 8 characters.',
      organizationRequired: 'ORG_REP users must be linked to an organization.',
    },
  },
  orgPortal: {
    seoTitle: 'Manage my organization',
    seoDesc: 'Update your organization profile, submit events for approval, and manage gallery and team.',
    badge: 'Organization representative portal',
    subtitle: 'Edit your public profile and submit events for admin approval.',
    refresh: 'Refresh',
    loading: 'Loading your organization portal…',
    backToOrgs: 'Back to organizations',
    viewPublic: 'View public page',
    accessDenied: 'Organization portal access required',
    accessDeniedDesc: 'This area is for organization representatives assigned by an administrator.',
    profileHint: 'Profile changes appear on your public page once published. Category and approval status are managed by admins.',
    eventsHint: 'Submitted events start as Pending until an admin approves them in Event approvals.',
    saveProfile: 'Save profile',
    profileSaved: 'Profile saved.',
    submitEvent: 'Submit for approval',
    eventSubmitted: 'Event submitted for admin approval.',
    noEvents: 'No events yet.',
    confirmDeleteEvent: 'Remove this pending event?',
    deletePending: 'Remove pending',
    reviewNote: 'Admin note',
    addGallery: 'Add photo',
    galleryAdded: 'Photo added.',
    addMember: 'Add team member',
    memberAdded: 'Team member added.',
    addDocument: 'Add document',
    documentAdded: 'Document added.',
    viewDocument: 'View file',
    upload: 'Upload',
    categoryDetails: 'Category-specific details',
    tabs: {
      profile: 'Profile',
      events: 'Events',
      gallery: 'Gallery',
      team: 'Team',
      documents: 'Documents',
    },
    fields: {
      name: 'Organization name',
      slug: 'URL slug',
      establishedYear: 'Established year',
      shortDescription: 'Short description',
      fullDescription: 'Full description',
      logo: 'Logo URL',
      coverImage: 'Cover image URL',
      email: 'Contact email',
      mobile: 'Mobile',
      whatsapp: 'WhatsApp',
      website: 'Website',
      district: 'District',
      city: 'City',
      address: 'Address',
      eventTitle: 'Event title',
      eventDate: 'Date',
      eventLocation: 'Location',
      eventDescription: 'Description',
      paidEvent: 'Paid / ticketed event',
      priceInr: 'Price (₹)',
      maxSeats: 'Max seats',
      registrationUrl: 'Registration URL',
      imageUrl: 'Image URL',
      caption: 'Caption',
      memberName: 'Name',
      memberRole: 'Role',
      memberEmail: 'Email',
      memberMobile: 'Mobile',
      docTitle: 'Title',
      docType: 'Type',
      docUrl: 'File URL',
    },
    errors: {
      load: 'Could not load organization portal.',
      save: 'Failed to save profile.',
      event: 'Event action failed.',
      gallery: 'Gallery action failed.',
      member: 'Team member action failed.',
      document: 'Document action failed.',
      upload: 'Upload failed.',
    },
  },
  about: {
    heritageBadge: 'Gadkot • Heritage • Maharashtra',
    heroSubtitle: "Your Digital Gateway to India's Magnificent Historical Heritage",
    startExploring: 'Start Exploring',
    discoverRoutes: 'Forts & Temples',
    whatSectionSubtitle: 'Discover our comprehensive digital heritage platform',
    digitalPlatformTitle: 'Digital Heritage Platform',
    digitalPlatformDesc:
      "Gadkot is a comprehensive digital platform dedicated to preserving, documenting, and sharing India's rich historical heritage across forts, temples, monuments, and cultural sites.",
    featureMaps: 'Interactive maps and virtual tours',
    featureHistory: 'Historical information and stories',
    featureAudio: 'Audio guides and multimedia content',
    primaryGoalsTitle: 'Our Primary Goals',
    primaryGoalsDesc:
      'We bridge historical sites and modern audiences — making heritage accessible, engaging, and educational for everyone.',
    goalDemocratize: 'Democratize access to historical knowledge',
    goalPreserve: 'Preserve cultural heritage digitally',
    goalInspire: 'Inspire heritage exploration and tourism',
    whoWeServeTitle: 'Who We Serve',
    whoWeServeDesc:
      'From history enthusiasts to students and researchers — our platform serves diverse audiences.',
    audienceResearchers: 'History enthusiasts and researchers',
    audienceStudents: 'Students and educational institutions',
    audienceTravelers: 'Travelers and cultural tourists',
    storyP1:
      'Gadkot began with a simple vision: make India\'s rich historical heritage accessible from anywhere. Founded by passionate history enthusiasts, we are building a comprehensive digital resource for exploration.',
    storyP2:
      'Most online resources were either too academic or too shallow. We wanted education and engagement in balance — authentic and accessible for all.',
    storyP3:
      'Today Gadkot is growing into a platform for forts, temples, and monuments with virtual tours, audio guides, and interactive maps.',
    statFounded: 'Founded',
    statFocus: 'Our Focus',
    statApproach: 'Our Approach',
    statFocusValue: 'History',
    statApproachValue: 'Digital',
    storyImageAlt: 'Our team working on heritage preservation',
    missionBadge: 'Mission: Preserve History',
    missionVisionSubtitle: 'Guiding principles for our digital heritage platform',
    missionFullDesc:
      'Democratize access to India\'s historical heritage through innovative digital experiences that educate, inspire, and connect people with our cultural legacy.',
    missionPoint1: 'Make historical exploration accessible to all',
    missionPoint2: 'Create engaging and educational content',
    missionPoint3: 'Preserve heritage through digital innovation',
    visionFullDesc:
      'Become the world\'s most comprehensive and trusted digital platform for historical exploration, where everyone can discover, learn, and contribute.',
    visionPoint1: 'Global recognition for heritage preservation',
    visionPoint2: 'Community-driven heritage documentation',
    visionPoint3: 'Technology-enabled cultural education',
    valuesSubtitle: 'The principles that guide everything we do at Gadkot',
    valuePreservationTitle: 'Preservation First',
    valuePreservationDesc: 'Committed to preserving and promoting India\'s cultural heritage for future generations.',
    valueCommunityTitle: 'Community Driven',
    valueCommunityDesc: 'Built by and for enthusiasts, with contributions from experts and users.',
    valueAccessibleTitle: 'Accessible to All',
    valueAccessibleDesc: 'Everyone should be able to learn about and explore historical sites.',
    valueInnovationTitle: 'Innovation Focus',
    valueInnovationDesc: 'Technology for immersive and educational historical experiences.',
    valueAuthenticTitle: 'Authentic Content',
    valueAuthenticDesc: 'Thoroughly researched and verified by historical experts.',
    valueUxTitle: 'User Experience',
    valueUxDesc: 'Intuitive, engaging, and informative experiences for our users.',
    platformFocusTitle: 'Our Platform Focus',
    platformFocusSubtitle: 'Core principles guiding our preservation efforts',
    focusHistoricalTitle: 'Historical Focus',
    focusHistoricalDesc: "Dedicated to preserving and sharing India's rich historical heritage",
    focusEducationalTitle: 'Educational Content',
    focusEducationalDesc: 'Comprehensive historical resources for learning and exploration',
    focusDigitalTitle: 'Digital Preservation',
    focusDigitalDesc: 'Leveraging technology to document and protect cultural heritage',
    focusMissionTitle: 'Mission-Driven',
    focusMissionDesc: 'Making history accessible and engaging for everyone',
    partnersTitle: 'Our Partners',
    partnersSubtitle: 'Organizations committed to heritage preservation',
    partnerAsi: 'Archaeological Survey of India',
    partnerAsiType: 'Government',
    partnerMahaTourism: 'Maharashtra Tourism',
    partnerMahaTourismType: 'Tourism Board',
    partnerHeritageTrust: 'Heritage Trust',
    partnerHeritageTrustType: 'NGO',
    partnerDigitalMuseum: 'Digital Museum Initiative',
    partnerDigitalMuseumType: 'Cultural',
    ctaTitle: 'Join Us on Our Historical Journey',
    ctaDesc:
      "We're on a mission to preserve and share India's rich historical heritage. Explore and grow with us.",
    getInTouch: 'Get in Touch',
    seoTitle: "About Gadkot — India's Historical Heritage",
    seoDescription:
      "Gadkot's mission, vision, and values — preserving and promoting India's historical heritage through digital innovation.",
  },
  emergency: {
    badge: 'Safety • Rescue • Hotlines',
    title: 'Emergency & Rescue',
    heroSubtitle: 'Quick access to national emergency services, Gadkot hotlines, fort trek contacts, and registered rescue groups.',
    tapToCall: 'Tap to call',
    nationalTitle: 'National emergency ({{number}})',
    nationalDesc: 'Police, fire, and ambulance — India unified emergency.',
    portalHotline: 'Gadkot emergency hotline',
    portalHotlineDesc: 'Portal-wide coordination during treks and heritage events.',
    rescueHotline: 'Rescue coordination',
    rescueHotlineDesc: 'Mountain / trek rescue coordination line.',
    fortTrekTitle: 'Fort-specific emergencies',
    fortTrekDesc: 'Each fort page lists local police, hospitals, and rescue contacts under Trek Essentials — add them in Admin → Fort trek guides.',
    browseForts: 'Browse forts',
    rescueGroupsTitle: 'Registered rescue groups',
    rescueGroupsDesc: 'Disaster management and rescue organizations listed on Gadkot.',
    viewAllRescueGroups: 'View all rescue groups',
    noRescueGroups: 'No rescue groups listed yet. Admins can add them under Organizations (category: Rescue Groups).',
    noHotlineListed: 'No 24×7 number listed — see organization profile.',
    viewOrgProfile: 'View organization profile',
    disclaimer: 'In life-threatening situations, call national emergency first. Gadkot lists community contacts for reference only.',
    seoTitle: 'Emergency & Rescue | Gadkot',
    seoDescription: 'National hotlines, Gadkot emergency numbers, fort trek contacts, and rescue group directory for Maharashtra heritage treks.',
  },
  contact: {
    heritageBadge: 'Contact • Support • Heritage',
    emergencyBannerTitle: 'Trek or heritage emergency?',
    emergencyBannerDesc: 'National hotlines, Gadkot coordination numbers, and registered rescue teams.',
    emergencyBannerCta: 'Open emergency hub',
    heroSubtitle:
      "We're here to help you explore India's rich heritage. Reach out with questions, feedback, or collaboration opportunities.",
    emailUs: 'Email Us',
    callUs: 'Call Us',
    visitUs: 'Visit Us',
    emailResponse: 'We typically respond within 24 hours',
    callHours: 'Mon–Fri, 9AM–6PM IST',
    visitAppointment: 'By appointment only',
    sendMessage: 'Send Us a Message',
    messageSent: 'Message Sent Successfully!',
    messageSentDesc: "We'll get back to you within 24 hours.",
    submitError: 'Could not send your message. Please try again or email gadkotheritage@gmail.com directly.',
    formName: 'Name',
    formEmail: 'Email',
    formSubject: 'Subject',
    formMessage: 'Message',
    formSubmit: 'Send Message',
    title: 'Contact Us',
    namePlaceholder: 'Your full name',
    emailPlaceholder: 'your@email.com',
    category: 'Category',
    categoryGeneral: 'General Inquiry',
    categoryTechnical: 'Technical Support',
    categoryContent: 'Content Contribution',
    categoryPartnership: 'Partnership',
    categoryMedia: 'Media & Press',
    subjectPlaceholder: "What's this about?",
    messagePlaceholder: 'Tell us more about your inquiry...',
    sending: 'Sending...',
    contactDepartments: 'Contact Our Departments',
    techDept: 'Technical Support',
    techDeptDesc: 'For website issues, bugs, or technical assistance',
    techEmail: 'tech@gadkot.com',
    contentTeam: 'Content Team',
    contentTeamDesc: 'For content corrections, suggestions, or contributions',
    contentEmail: 'content@gadkot.com',
    partnershipsDept: 'Partnerships',
    partnershipsDeptDesc: 'For collaboration opportunities and partnerships',
    partnershipsEmail: 'partnerships@gadkot.com',
    mediaDept: 'Media & Press',
    mediaDeptDesc: 'For media inquiries and press releases',
    mediaEmail: 'media@gadkot.com',
    mondayFriday: 'Monday - Friday:',
    mondayFridayHours: '9:00 AM - 6:00 PM IST',
    saturday: 'Saturday:',
    saturdayHours: '10:00 AM - 4:00 PM IST',
    sunday: 'Sunday:',
    sundayClosed: 'Closed',
    holidays: 'Holidays:',
    holidaysClosed: 'Closed on major Indian holidays',
    ourLocation: 'Our Location',
    addressLabel: 'Address:',
    addressValue: 'Pune, Maharashtra, India',
    visitsLabel: 'Visits:',
    visitsValue: 'By appointment only',
    timezoneLabel: 'Time Zone:',
    timezoneValue: 'Indian Standard Time (GMT+5:30)',
    pageFaq1Q: 'How quickly will I receive a response?',
    pageFaq1A:
      'We typically respond within 24 hours on business days. Technical issues are prioritized and usually resolved within 4–6 hours.',
    pageFaq2Q: 'Can I contribute content to Gadkot?',
    pageFaq2A:
      'Yes! We welcome contributions from history enthusiasts, photographers, and researchers. Contact our content team with your ideas.',
    pageFaq3Q: 'Do you offer guided tours or partnerships?',
    pageFaq3A:
      'We partner with local guides and heritage organizations. Contact our partnerships team to explore collaboration.',
    pageFaq4Q: 'How can I report an error or suggest an improvement?',
    pageFaq4A:
      'Use our contact form or email tech@gadkot.com. We appreciate feedback that helps improve our platform.',
    seoTitle: 'Contact Gadkot — Support & Inquiries',
    seoDescription:
      "Contact Gadkot for support, partnerships, or general inquiries. Find our email, phone numbers, and office hours.",
  },
  blog: {
    title: 'Heritage Blog',
    subtitle: 'Discover stories, insights, and experiences from history enthusiasts and travelers',
    heritageBadge: 'Stories of Maratha heritage',
    themeForts: 'Forts',
    themeTemples: 'Temples',
    themeHistory: 'History',
    themeCulture: 'Culture',
    themeTravel: 'Travel',
    allPosts: 'All Posts',
    addBlog: 'Add Blog',
    signInToSubmit: 'Sign in to submit a blog post.',
    shareYourStory: 'Share Your Story',
    titlePlaceholder: 'Enter blog title...',
    contentPlaceholder: 'Share your historical insights, experiences, or stories...',
    tagsPlaceholder: 'history, forts, temples, travel...',
    featured: 'Featured',
    loadingBlogs: 'Loading blogs...',
    writeFirstBlog: 'Write First Blog',
    beFirstToShare: 'Be the first to share your historical insights!',
    tryAdjustingSearch: 'Try adjusting your search terms',
    reviewProcessTitle: 'Review Process',
    reviewProcessDesc:
      'Your blog will be reviewed by our admin team before being published. This typically takes 24–48 hours.',
    dropImages: 'Drop images here or click to upload',
    chooseImages: 'Choose Images',
    submittedSuccess: 'Blog submitted for review! It will be visible once approved by admin.',
    submitFailed: 'Failed to submit blog',
    linkCopied: 'Link copied to clipboard!',
    notFound: 'Blog not found',
    notFoundDesc: "The blog you're looking for doesn't exist.",
    backToBlog: 'Back to Blog',
    loadingBlog: 'Loading blog...',
    guest: 'Guest',
    defaultCategory: 'Blog',
    categories: {
      forts: 'Forts',
      temples: 'Temples',
      historical: 'Historical sites',
      culture: 'Culture',
      travel: 'Travel',
    },
    articleBody: 'Article',
    aboutPost: 'About this post',
    writtenBy: 'Author',
    publishedOn: 'Published',
    categoryLabel: 'Category',
    tagsLabel: 'Tags',
    seoTitle: 'Heritage Blog — Historical Stories | Gadkot',
    seoDescription:
      "Read and share stories about India's historical forts, temples, and cultural heritage.",
  },
  wades: {
    title: 'Wades',
    subtitle: 'Historic mansions, wadas, and cultural heritage of Maharashtra',
    heritageBadge: 'Maharashtra Heritage • Wades',
    intro:
      'Wadas are living witnesses to Maharashtra’s social, political, and cultural history. Explore famous mansions and historic residences with full details, features, and best times to visit.',
    loading: 'Loading wadas…',
    loadError: 'Could not load wadas',
    noWadas: 'No wadas available at the moment',
    wadasFound: 'wadas found',
    searchPlaceholder: 'Search wada, district, place…',
    allDistricts: 'All districts',
    bestTime: 'Best time to visit',
    seoTitle: 'Wades — Historic Heritage | Gadkot',
    seoDescription:
      'Famous wadas and historic residences of Maharashtra — Shaniwar Wada, Nana Wada, Lal Mahal, Vishrambaug Wada, and more.',
  },
  history: {
    title: 'History',
    subtitle: 'Chronicles of Maharashtra\'s forts, empires, and cultural heritage',
    heritageBadge: 'Heritage Chronicles • Itihas',
    intro:
      'Explore curated historical articles — from single narratives to multi-part series covering dynasties, battles, and the stories behind our forts.',
    searchPlaceholder: 'Search history, era, or topic…',
    loading: 'Loading historical articles…',
    loadError: 'Could not load historical information. Please try again.',
    noArticles: 'No articles found',
    tryDifferentSearch: 'Try a different search or category',
    featured: 'Featured',
    partsCount: '{{count}} parts',
    readMore: 'Read article',
    readSeries: 'Read series',
    backToList: 'Back to History',
    partLabel: 'Part {{number}} of {{total}}',
    partShort: 'Part {{number}}',
    previousPart: 'Previous part',
    nextPart: 'Next part',
    seoTitle: 'History — Heritage Chronicles | Gadkot',
    seoDescription:
      'Historical information about Maratha Swarajya, Sahyadri forts, battles, and Maharashtra\'s cultural legacy.',
    categories: {
      all: 'All',
      'maratha-empire': 'Maratha Empire',
      'forts-history': 'Forts History',
      battles: 'Battles',
      culture: 'Culture & Society',
      dynasties: 'Dynasties',
      general: 'General',
    },
    tithiCalendarLink: 'Full-year history by tithi (Gudi Padwa → Rang Panchami)',
    compendiumLink: 'Complete history archive (forts, sardars, map)',
    indiaMapLink: 'India historic map — forts, wars, temples',
    heritageHubLink: 'Heritage Hub — Bhakta Gadkot, sardars, places',
  },
  tithiCalendar: {
    badge: 'Tithi calendar • History',
    title: 'Full-year history mapped by tithi',
    subtitle:
      'From Gudi Padwa to Rang Panchami — festivals and historic events on each month, paksha, and tithi. Three phases: Shiv era, Peshwa era, and British era.',
    seoTitle: 'Tithi calendar — Shiv-era history | Gadkot',
    seoDescription:
      'Maratha history by Hindu tithi: Ram Navami — Lal Mahal raid, Guru Purnima — Pavan Khind, Sinhagad — Tanaji, and many festivals and battles.',
    phase: 'Phase {{n}}',
    phasePending: '{{era}} — this phase will be added soon. Shiv-era mapping is complete.',
    loadError: 'Could not load the tithi calendar.',
    kindSan: 'Festival',
    kindItihas: 'History',
    kindBoth: 'Festival + history',
    stats: {
      events: 'Total events',
      festivals: 'Festivals',
      history: 'Historic',
      tithis: 'Tithis (with events)',
    },
    footerNote: 'Admins can add events from the admin panel.',
    backHistory: 'Back to History',
    compendiumLink: 'Complete history archive',
    kindInfo: 'Panchang info',
    showPanchang: 'Show panchang info',
    noEventsTitle: 'No event records found',
    noEventsHint:
      'Shiv-era events are not in the database yet. Run scripts/mysql_tithi_history_all_in_one.sql on MySQL, or restart the backend (auto-seed). Then Gudi Padwa, coronation, Sinhagad, etc. will appear on their tithis.',
    onMap: 'On map',
    mapSection: 'Historic location — map',
    mapSectionHint: 'Fort or historic place linked to this event.',
    viewMap: 'Map view',
    viewScroll: 'Scroll view',
    mapYearLabel: 'Hindu year — tithi map',
    mapHint: 'Tap a month region to explore paksha trails and events.',
    mapSelectMonth: 'Select a month on the map above to see tithi trails.',
    mapTithiShort: 'tithis',
    mapLegendEvents: 'Events recorded',
    mapLegendInfo: 'Panchang info',
    mapLegendEmpty: 'No entry',
    mapLegendToday: "Today's tithi",
    mapTodayBadge: 'Today',
    mapTodayMonth: "Today's month",
  },
  indiaHistoricMap: {
    badge: 'Interactive map • Heritage',
    title: 'India historic map',
    subtitle:
      'Explore forts, battlefields, temples, palaces, and historic events across India. The map stays locked to India — click any marker for full details.',
    seoTitle: 'India historic map — forts, wars, temples | Gadkot',
    seoDescription:
      'Interactive map of forts, war sites, temples, and historic places in India with links to detailed pages.',
    backHistory: 'Back to History',
    searchPlaceholder: 'Search fort, temple, battle, place…',
    loadError: 'Could not load map data.',
    noResults: 'No places match your filters. Try another layer or search.',
    mapHint: 'Click a marker or list item to zoom in. Open the detail page for full history.',
    listTitle: 'Places on map',
    placesOnMap: 'places',
    viewDetail: 'View details',
    legend: 'Legend',
    mapLabel: 'Subcontinent atlas',
    mapTitle: 'Historic India',
    indiaOnlyHint: 'Pan and zoom within India only — heritage sites across the subcontinent.',
    categories: {
      fort: 'Fort',
      temple: 'Temple',
      battlefield: 'War site',
      palace: 'Palace',
      historic: 'Historic place',
      event: 'Historic event',
    },
  },
  tithiCompendium: {
    badge: 'Complete archive • History',
    title: 'Tithi history — complete archive',
    subtitle: 'Beyond day-by-day: all events, forts, commanders, and map locations in one place.',
    seoTitle: 'Tithi history archive | Gadkot',
    seoDescription: 'Shiv, Peshwa, and British eras — full historic events with forts, sardars, and interactive map.',
    backCalendar: 'Back to tithi calendar',
    searchPlaceholder: 'Search event, fort, commander, place…',
    viewList: 'List',
    viewMap: 'Map',
    loadError: 'Could not load the archive.',
    noResults: 'No results found.',
    mapHint: 'Click markers on the map to see forts and events.',
    stats: {
      events: 'Events',
      forts: 'Forts',
      places: 'On map',
    },
  },
  heritage: {
    backHub: 'Back to Heritage Hub',
    hub: {
      badge: 'Maharashtra heritage • Gadkot',
      title: 'Heritage Hub',
      subtitle:
        'Bhakta Gadkot, sardars, historic places, partners, and visit planning — deeper than trek info alone.',
      seoTitle: 'Heritage Hub — Bhakta Gadkot, sardars, places | Gadkot',
      seoDescription:
        'Devotional fort guides, commander profiles, historic sites, books & trek partners, crowd-aware visit planning.',
      stats: {
        sardars: 'Sardars',
        places: 'Places',
        bhakti: 'Bhakti guides',
        partners: 'Partners',
        visit: 'Visit planning',
      },
    },
    modules: {
      gallery: {
        title: 'Heritage Gallery',
        desc: 'Photos from forts, temples, wadas, weapons, organizations, and community treks.',
      },
      indiaMap: {
        title: 'India historic map',
        desc: 'Forts, war sites, temples, and historic places on one interactive map.',
      },
      bhakta: {
        title: 'Bhakta Gadkot',
        desc: 'Deities, darshan, puja, festivals — richer than trek essentials.',
      },
      sardars: {
        title: 'Sardars',
        desc: 'Chhatrapati, generals, heroes — biography, deeds, linked forts.',
      },
      places: {
        title: 'Historic places',
        desc: 'Forts, battlefields, palaces — each as its own domain.',
      },
      partners: {
        title: 'Partners',
        desc: 'Books, trek operators, tourism — featured in relevant sections.',
      },
      books: {
        title: 'Heritage Books',
        desc: 'Free PDF library — fort history, guides, tithi calendars, and devotional texts.',
      },
      visit: {
        title: 'Visit planning',
        desc: 'Capacity, slots, parking — crowd and traffic management.',
      },
    },
    gallery: {
      badge: 'Maharashtra heritage • Photos',
      title: 'Heritage Gallery',
      subtitle:
        'Browse curated images from forts, temples, wadas, weapons, heritage organizations, and approved community contributions.',
      seoTitle: 'Heritage Gallery — forts, temples & community photos | Gadkot',
      seoDescription:
        'Explore Maharashtra heritage photos: forts, sacred places, historic wadas, arms, organization galleries, and trekker submissions.',
      loading: 'Loading gallery…',
      loadingMore: 'Loading more images…',
      loadError: 'Could not load gallery images.',
      empty: 'No images match your filters.',
      searchPlaceholder: 'Search by place, caption…',
      resultsCount: '{{count}} images',
      loadMore: 'Load more',
      contributeCta: 'Share your trek photos',
      viewSource: 'View source page',
      filters: {
        all: 'All',
      },
      types: {
        FORT: 'Fort',
        TEMPLE: 'Temple',
        WADA: 'Wada',
        WEAPON: 'Weapon',
        ORGANIZATION: 'Organization',
        COMMUNITY: 'Community',
      },
    },
    bhakta: {
      title: 'Bhakta Gadkot',
      intro:
        'The spiritual view of forts — deities, darshan timings, puja, festivals, yatri etiquette. Not trek info; dedicated devotional content.',
      seoTitle: 'Bhakta Gadkot — devotional fort guides | Gadkot',
      seoDescription: 'Deities, darshan, puja, festivals, and bhakti routes on Maharashtra forts.',
      empty: 'No bhakti guides available yet. More will be added soon.',
      vsTrekNote: 'Trek info (route, distance, safety) lives elsewhere — this section is devotional only.',
      panelTitle: 'Bhakta Gadkot — devotional guide',
      panelEmpty: 'No bhakti guide added for this fort yet.',
      exploreAll: 'Explore all bhakti forts',
      deities: 'Deities',
      significance: 'Spiritual significance',
      timings: 'Darshan timings',
      puja: 'Puja vidhi',
      festivals: 'Festivals',
      etiquette: 'Yatri etiquette',
      offerings: 'Offerings',
      legends: 'Legends & stories',
      routes: 'Bhakti routes',
    },
    sardars: {
      title: 'Sardars',
      intro: 'Heroes of Shiv, Peshwa, and later eras — biography, war details, village, clan, and linked forts.',
      seoTitle: 'Sardars — Maratha heroes | Gadkot',
      seoDescription: 'Shivaji Maharaj, Tanaji, Bajiprasad, and more — full historic profiles.',
      back: 'All sardars',
      biography: 'Biography',
      deeds: 'Famous deeds',
      forts: 'Linked forts',
      places: 'Linked historic places',
      warDetails: 'War details',
      battles: 'Major battles & campaigns',
      weapons: 'Weapons & arms',
      allies: 'Allies & associates',
      enemies: 'Enemies & opponents',
      memorial: 'Memorial & samadhi',
      honors: 'Honors & titles',
      legacy: 'Historic legacy',
      sources: 'Sources & references',
      village: 'Native village',
      district: 'District',
      clan: 'Clan / family',
      lifespan: 'Lifespan',
      deathPlace: 'Death place',
      eraAll: 'All eras',
      eraShiv: 'Shiv era',
      eraPeshwa: 'Peshwa era',
      eraBritish: 'British era',
      empty: 'No sardars found for this era.',
      count: '{count} sardars',
      viewProfile: 'View full profile',
    },
    places: {
      title: 'Historic places',
      intro: 'Forts, battlefields, palaces — each place as an independent work domain.',
      seoTitle: 'Historic places | Gadkot',
      seoDescription: 'Raigad, Pavan Khind, Lal Mahal, Pratapgad, Sinhagad — historic site profiles.',
      back: 'All places',
      viewFort: 'View fort page',
    },
    partners: {
      title: 'Partners',
      intro: 'Books, trek groups, tourism bodies — featured in the sections they belong to.',
      website: 'Website',
    },
    visit: {
      title: 'Visit planning',
      hubTitle: 'Visit planning & crowd management',
      hubIntro:
        'Monsoon, Navratri, Diwali — even easy-access sites get crowded. Capacity, slots, parking, and entry planning.',
      seoTitle: 'Visit planning — registration & capacity | Gadkot',
      seoDescription: 'Crowd management, daily caps, slots, parking — ready for MTDC collaboration.',
      tourismVision:
        'Long-term: registration, passes, slots, and traffic management — for a Maharashtra Tourism proposal.',
      registrationRequired: 'Registration / slot required',
      dailyCap: 'Daily capacity',
      slotCap: 'Per slot',
      parking: 'Parking',
      peak: 'Peak seasons',
      entry: 'Entry points',
    },
    booking: {
      title: 'Fort visit — book a ticket',
      intro: 'Choose a time slot for crowd management. Keep your confirmation code for entry.',
      date: 'Visit date',
      slot: 'Time slot',
      selectSlot: 'Select a time slot',
      visitors: 'Number of visitors',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      submit: 'Book ticket',
      confirmed: 'Ticket booked!',
      confirmedHint: 'Show this confirmation code at the fort. Save a screenshot.',
      confirmationCode: 'Confirmation code',
      fort: 'Fort',
      bookAnother: 'Book another ticket',
      dailyRemaining: 'Remaining daily capacity',
      noSlots: 'No slots available on this date. Try another date.',
      loadSlotsError: 'Could not load time slots.',
      bookError: 'Booking failed. Please try again.',
      bookOnFort: 'Book ticket on fort page',
      passTitle: 'Entry pass',
      qrHint: 'Scan this QR at the fort gate',
      printPass: 'Print / save pass',
      free: 'Free',
      amount: 'Amount',
      emailSent: 'Email sent',
      smsSent: 'SMS sent',
      ticketPrice: 'Ticket price',
      perPerson: 'per person',
      estimatedTotal: 'Estimated total',
      submitPaid: 'Book & pay',
      paymentPending: 'Payment pending',
      paymentPendingHint: 'Code {{code}} — amount {{amount}}. Complete payment to confirm.',
      payNow: 'Pay now',
      demoPay: 'Demo payment (dev)',
      paymentError: 'Payment failed',
      paymentCancelled: 'Payment cancelled',
      lookupTitle: 'Find your ticket',
      lookupIntro: 'Enter your confirmation code to view your QR pass.',
      lookupBtn: 'Look up',
      notFound: 'Booking not found',
      pendingOnLookup: 'Payment pending — complete payment from the fort page.',
      cancelledOnLookup: 'This booking has been cancelled.',
    },
  },
  footer: {
    location: 'Mumbai, Maharashtra',
  },
  shop: {
    title: 'Heritage Shop',
    badge: 'Official Gadkot store',
    heroSubtitle: 'Books on Maratha history, trek essentials, digital guides, and heritage merchandise — shipped across India.',
    seoTitle: 'Heritage Shop | Gadkot',
    seoDescription: 'Buy heritage books, trek gear, digital fort guides, and Gadkot merchandise.',
    searchPlaceholder: 'Search products…',
    categories: {
      all: 'All',
      books: 'Books',
      trekGear: 'Trek gear',
      digital: 'Digital',
      merch: 'Merchandise',
    },
    addToCart: 'Add to cart',
    inStock: 'In stock',
    outOfStock: 'Out of stock',
    cartTitle: 'Cart',
    cartEmpty: 'Your cart is empty.',
    remove: 'Remove',
    total: 'Total',
    checkout: 'Checkout',
    backToShop: 'Back to shop',
    loadError: 'Could not load products.',
    noProducts: 'No products found.',
    checkoutTitle: 'Checkout',
    orderSummary: 'Order summary',
    name: 'Full name',
    email: 'Email',
    addressEmailHint: 'If a previous address is securely available for this email, it will be filled in.',
    previousAddresses: 'Choose a previous address',
    loadingAddresses: 'Looking for previous addresses…',
    phone: 'Phone',
    address: 'Shipping address',
    city: 'City',
    pincode: 'PIN code',
    placeOrder: 'Place order & pay',
    checkoutError: 'Checkout failed. Please try again.',
    paymentPending: 'Payment pending',
    paymentPendingHint: 'Order {{code}} — {{amount}}. Complete payment to confirm.',
    payNow: 'Pay now',
    demoPay: 'Demo payment (dev)',
    paymentError: 'Payment failed',
    paymentCancelled: 'Payment cancelled',
    orderDescription: 'Gadkot shop order {{code}}',
    orderTitle: 'Order details',
    orderConfirmed: 'Order confirmed!',
    orderConfirmedHint: 'Thank you! We will process your order and email you updates.',
    orderCode: 'Order code',
    status: 'Status',
    statuses: {
      PENDING_PAYMENT: 'Pending payment',
      PAID: 'Paid',
      CANCELLED: 'Cancelled',
    },
    orderNotFound: 'Order not found',
    completePayment: 'Complete payment',
    continueShopping: 'Continue shopping',
  },
  fortQa: {
    title: 'AI Fort Guide',
    globalTitle: 'AI Fort Guide',
    subtitle: 'Ask about {{name}} — answers from Gadkot CMS data',
    globalSubtitle: 'Ask about any Maharashtra fort — we detect the fort from your question',
    globalHero: 'History, trek routes, directions, timings — powered by Gadkot heritage data. Type or speak in Marathi.',
    seoTitle: 'AI Fort Guide | Gadkot',
    seoDescription: 'Marathi & English Q&A about Maharashtra forts from Gadkot CMS — history, trek, directions.',
    thisFort: 'this fort',
    cmsBadge: 'CMS-powered',
    placeholder: 'Ask in Marathi or English…',
    send: 'Send',
    thinking: 'Searching Gadkot records…',
    emptyHint: 'Try a suggested question or type your own about history, trek, or directions.',
    globalEmptyHint: 'Name a fort in your question, e.g. "रायगड कसा जायचा?" or use the mic to speak.',
    error: 'Could not get an answer. Please try again.',
    aiPowered: 'AI answer',
    aiError: 'AI issue',
    disclaimer: 'Answers use Gadkot fort, trek, and heritage data. Verify critical travel details before visiting.',
    viewFort: 'View {{name}}',
    voiceStart: 'Speak your question',
    voiceStop: 'Stop listening',
    voiceDenied: 'Microphone access denied. Allow mic permission in your browser.',
    voiceError: 'Voice input failed. Type your question instead.',
    voiceUnsupported: 'Voice input works in Chrome/Edge on desktop and Android.',
    listening: 'Hearing',
    sources: {
      fort: 'Fort profile',
      trekGuide: 'Trek guide',
      bhaktiGuide: 'Bhakti guide',
      practicalInfo: 'Practical info',
      unknown: 'CMS',
    },
  },
  pwa: {
    install: 'Install app',
    installHint: 'Install Gadkot for offline trek checklists and maps on the trail.',
    offline: {
      title: 'Offline trek packs',
      subtitle: 'Download fort guide, emergency contacts, and map tiles before you lose signal.',
      online: 'Online',
      offline: 'Offline',
      cached: 'Offline — cached list',
      checklistEmpty: 'No checklist cached yet. Open this tab once while online.',
      storage: 'Storage: {{used}} MB / {{total}} MB',
      downloadFort: 'Download fort pack + map',
      downloading: 'Downloading',
      needOnline: 'Connect to the internet to download new packs.',
      downloadError: 'Download failed. Try again when online.',
      empty: 'No offline packs yet. Pick a fort above and download.',
      tilesSaved: '{{count}} map tiles saved',
      packOnly: 'Guide saved — map tiles pending',
    },
  },
  community: {
    badge: 'Community & growth',
    title: 'Gadkot Community',
    hero: 'Sell heritage content, join paid treks, earn rewards, invite friends, and get WhatsApp reminders.',
    seoTitle: 'Community — Creators, Rewards & Referrals | Gadkot',
    seoDescription: 'Creator marketplace, org paid events, contribution rewards, referral program, and WhatsApp trek alerts.',
    error: 'Something went wrong. Try again.',
    tabs: {
      creators: 'Creators',
      marketplace: 'Paid events',
      rewards: 'Rewards',
      referral: 'Invite friends',
      alerts: 'WhatsApp alerts',
    },
    creators: {
      subtitle: 'Photographers and historians sell prints, guides, and research — reviewed by Gadkot.',
      applyTitle: 'Join the creator program',
      name: 'Your name',
      role: 'Title (e.g. Photographer)',
      listingTitle: 'Listing title',
      description: 'Description',
      fort: 'Related fort',
      priceInr: 'Price (₹, optional)',
      submit: 'Submit for review',
      submitted: 'Submitted — we will review your listing.',
      buy: 'View / purchase',
      myCount: '{{count}} listing(s) submitted by you',
      empty: 'No creator listings yet.',
      emptyDesc: 'If you are a photographer, historian, or guide, apply below — yours could be the first listing here.',
      applyCta: 'Apply to the creator program',
      types: { PHOTO: 'Photo', ARTICLE: 'Article', GUIDE: 'Guide', RESEARCH: 'Research' },
    },
    marketplace: {
      subtitle: 'Trek groups and orgs list paid events on the Gadkot calendar.',
      viewCalendar: 'Open events calendar',
      empty: 'No paid events yet. Trek groups can submit via Events → Add event.',
      register: 'Register / pay',
      paidEvent: 'Paid event (marketplace)',
      priceInr: 'Ticket price (₹)',
      registrationUrl: 'Registration or payment link',
      maxSeats: 'Max seats',
      paidFrom: 'From ₹{{price}}',
    },
    rewards: {
      signIn: 'Sign in to see your heritage reward points.',
      balance: 'Your points',
      shopCredit: 'shop credit',
      redeemShop: 'Redeem at shop checkout',
      earnContribution: '+{{pts}} when your contribution is approved',
      earnReview: '+{{pts}} for your first fort review',
      earnReferral: '+{{pts}} when a friend joins with your code',
      history: 'Recent activity',
      usePoints: 'Use reward points (balance: {{balance}})',
    },
    referral: {
      subtitle: 'Invite friends to explore Maharashtra heritage on Gadkot.',
      signIn: 'Sign in to get your invite link.',
      yourCode: 'Your referral code',
      invites: '{{count}} friends joined',
      copyLink: 'Copy invite link',
      copied: 'Copied!',
      shareText: 'Join me on Gadkot — forts, treks & heritage:',
      codeOptional: 'Referral code (optional)',
      codePlaceholder: 'Friend\'s code',
    },
    alerts: {
      subtitle: 'Get event and trek reminders via WhatsApp (opens WhatsApp with a pre-filled message).',
      signIn: 'Sign in to save alert preferences.',
      eventReminders: 'Event reminders',
      trekUpdates: 'Trek plan updates',
      phone: 'WhatsApp number (optional)',
      save: 'Save preferences',
      saved: 'Preferences saved',
      hint: 'Use “Remind on WhatsApp” on any event card to send yourself a reminder.',
      remindWhatsApp: 'Remind on WhatsApp',
    },
  },
  education: {
    loadError: 'Education content could not be loaded.',
    back: 'Back',
    minutes: 'minutes',
    keyPoints: 'Key points',
    learn: {
      badge: 'Heritage learning paths',
      title: 'Learn Maharashtra Heritage',
      subtitle: 'Structured courses in Swarajya history, fort architecture, and exam revision.',
      overall: '{{progress}}% overall progress',
      lessonCount: '{{count}} lessons',
      markComplete: 'Mark lesson complete',
      markIncomplete: 'Mark incomplete',
      seoTitle: 'Heritage Learning Paths | Gadkot',
    },
    notes: {
      title: 'Exam Prep & Short Notes',
      subtitle: 'Focused one-page revision for MPSC, tourism, and heritage students.',
      search: 'Search topics and notes…',
      all: 'All categories',
      open: 'Open note',
      examTips: 'Exam tips',
      download: 'Download notes',
      print: 'Print',
      seoTitle: 'MPSC Heritage Short Notes | Gadkot',
    },
    institution: {
      title: 'School & College Portal',
      subtitle: 'Plan educational fort visits and download classroom-ready heritage worksheets.',
      worksheets: 'Worksheets',
      download: 'Download PDF/DOC',
      worksheetHint: 'Printable classroom-ready PDF or Word worksheets — download directly for your students.',
      emptyTitle: 'No worksheets available yet',
      emptyDesc: 'PDF or Word files will appear here once uploaded by the admin team.',
      bookTitle: 'Request a group visit',
      bookSubtitle: 'Submit your preferred fort, date, student count, and learning level.',
      name: 'Institution name',
      school: 'School',
      college: 'College',
      contact: 'Coordinator name',
      email: 'Email',
      phone: 'Phone',
      fort: 'Preferred fort',
      students: 'Number of students',
      grade: 'Grade / course',
      notes: 'Accessibility, transport, or learning requirements',
      submit: 'Submit visit request',
      success: 'Request #{{id}} submitted. The Gadkot team will contact you.',
      seoTitle: 'School & College Heritage Visits | Gadkot',
    },
    audio: {
      title: 'Marathi Audiobook Library',
      subtitle: 'Listen to fort stories, battles, legends, and heritage explainers in Marathi.',
      listen: 'Listen',
      stop: 'Stop',
      chapters: 'chapters',
      recorded: 'Recorded audio',
      mp3Hint: 'All audiobooks are played from uploaded MP3 files for a consistent experience on every device.',
      emptyTitle: 'No audiobooks available yet',
      emptyDesc: 'Recorded MP3 files will appear here once uploaded by the admin team.',
      seoTitle: 'Marathi Fort Audiobooks | Gadkot',
    },
  },
  books: {
    title: 'Heritage Books',
    subtitle: 'Read Maharashtra fort history, guides, tithi calendars, and devotional texts online — free PDF library.',
    seoTitle: 'Heritage Books — Marathi fort history PDFs | Gadkot',
    seoDescription: 'Browse and read free heritage books: fort guides, history, devotional texts, and Gadkot publications.',
    searchPlaceholder: 'Search by title or author…',
    emptyTitle: 'No books available yet',
    emptyDesc: 'PDF books will appear here once published by the admin team.',
    resultsCount: '{{count}} books',
    readOnline: 'Read online',
    pageCount: '{{count}} pages',
    backToLibrary: 'Back to library',
    notFound: 'Book not found.',
    downloadPdf: 'Download PDF',
    freeToRead: 'Free to read',
    byAuthor: 'By {{author}}',
    openInNewTab: 'Open PDF in new tab',
    readerHint: 'If the reader does not load, use “Open PDF in new tab” or download.',
    filters: { all: 'All' },
    categories: {
      HISTORY: 'History',
      FORT: 'Forts',
      DEVOTIONAL: 'Devotional',
      TITHI: 'Tithi & calendar',
      GUIDE: 'Guides',
      OTHER: 'Other',
    },
    licenses: {
      PUBLIC_DOMAIN: 'Public domain',
      GADKOT_ORIGINAL: 'Gadkot original',
      PARTNER: 'Partner publication',
    },
  },
  adminBooks: {
    title: 'Heritage books',
    subtitle: 'Upload PDFs and covers for the free online library at /books.',
    refresh: 'Refresh',
    addBook: 'Add book',
    editBook: 'Edit book',
    slug: 'URL slug',
    category: 'Category',
    titleEn: 'Title (English)',
    titleMr: 'Title (Marathi)',
    authorEn: 'Author (English)',
    authorMr: 'Author (Marathi)',
    descriptionEn: 'Description (English)',
    descriptionMr: 'Description (Marathi)',
    coverUrl: 'Cover image',
    pdfUrl: 'PDF file',
    pdfHint: 'Upload a PDF — required for publishing.',
    language: 'Language',
    license: 'License',
    pageCount: 'Page count',
    sortOrder: 'Display priority',
    isFree: 'Free to read',
    allowDownload: 'Allow download',
    active: 'Published',
    save: 'Save',
    cancel: 'Cancel',
    empty: 'No books yet. Add your first PDF.',
    colTitle: 'Title',
    colCategory: 'Category',
    colStatus: 'Status',
    colActions: 'Actions',
    published: 'Published',
    draft: 'Draft',
    edit: 'Edit',
    delete: 'Delete',
    loadError: 'Could not load books.',
    saveError: 'Could not save book.',
    deleteError: 'Could not delete book.',
    confirmDelete: 'Delete this book permanently?',
    errors: {
      pdfRequired: 'A PDF file is required.',
      pdfOnly: 'Only PDF files are allowed.',
    },
  },
  mobile: {
    back: 'Back',
    close: 'Close',
    backHome: 'Back to home',
    tabs: {
      label: 'Main navigation',
      home: 'Home',
      forts: 'Forts',
      trek: 'Trek',
      temples: 'Temples',
      menu: 'Menu',
    },
    home: {
      greeting: 'Welcome to Gadkot',
      title: 'Explore Maharashtra heritage',
      searchPlaceholder: 'Search forts, temples, places…',
      quickActions: 'Quick actions',
      featuredForts: 'Featured forts',
      seeAll: 'See all',
    },
    actions: {
      nearby: 'Nearby forts',
      search: 'Search',
      events: 'Events',
      heritage: 'Heritage',
    },
    settings: {
      title: 'App settings',
      apiTitle: 'Backend server',
      apiHint: 'If data does not load, set your API URL. Use your PC IP when testing locally (e.g. http://192.168.1.5:8080). Production: https://gadkot.com',
      apiLabel: 'API base URL',
      examples: 'Examples: https://gadkot.com · http://192.168.1.5:8080',
      save: 'Save',
      saved: 'Saved',
      test: 'Test connection',
      testOk: 'Connected — forts API works',
      testFail: 'Could not connect. Check URL, Wi‑Fi, and that the backend is running.',
      reset: 'Reset to default',
    },
  },
};
